{
  "version": "1.0",
  "builder": "dvm-layout",
  "relationHops": {
    "enabled": true,
    "categoryIds": ["inputs"],
    "title": "Relations",
    "hint": "Pick a target entity, then its search and extract attributes, then click Add. Added relations are included when you generate or update this configuration.",
    "dropdowns": [
      {
        "id": "targetEntity",
        "label": "Target Entity",
        "placeholder": "Select target entity",
        "mapTo": "targetEntity",
        "required": true,
        "optionsApi": {
          "url": "/getAllEntities/NontimeSeriesEntities",
          "method": "GET",
          "valuePath": "",
          "labelPath": ""
        }
      },
      {
        "id": "searchAttribute",
        "label": "Search Attribute",
        "placeholder": "Select search attribute",
        "mapTo": "searchAttribute",
        "required": true,
        "dependsOn": ["targetEntity"],
        "optionsApi": {
          "url": "/getEntityAttributes/NontimeSeriesEntities/{selections.targetEntity}",
          "method": "GET",
          "valuePath": "",
          "labelPath": ""
        }
      },
      {
        "id": "extractAttribute",
        "label": "Extract Attribute",
        "placeholder": "Select extract attribute",
        "mapTo": "extractAttribute",
        "required": true,
        "dependsOn": ["targetEntity"],
        "optionsApi": {
          "url": "/getEntityAttributes/NontimeSeriesEntities/{selections.targetEntity}",
          "method": "GET",
          "valuePath": "",
          "labelPath": ""
        }
      }
    ]
  },
  "steps": [
    {
      "id": "workbench",
      "label": "DVM Layout Workbench",
      "sections": [
        {
          "id": "workbench",
          "fields": [
            {
              "field": "dvmLayoutWorkbench"
            }
          ]
        }
      ]
    }
  ],
  "// chartConfigs": "Per-chart config files, one per chart family, under assets/self-service-config/charts/. The builder loads THIS shell first, then deep-merges each listed file into it (layoutSteps merged by key; options merged per-key — objects deep, arrays concatenated). Each chart owns its builder steps + its option lists + its Format-popup controls in its own file. Adding a chart = drop a new file here and list its name. A missing/broken file is skipped (merges empty), never blanking the builder. NOTE: only `bar-column` is config-DRIVEN at render time; the others still render via their built-in component logic — these files only supply their builder-UI config.",
  "chartConfigs": [
    "nested-table",
    "bar-column",
    "line-area",
    "scatter-bubble",
    "pie-composition",
    "waterfall",
    "drill-down-table",
    "table-matrix",
    "kpi-card",
    "input-control",
    "popup"
  ],
  "// layoutSteps": "Per-chart builder steps, keyed by the layoutType value. Each chart has its OWN block so they can be edited independently. Every section lists its fields (controls). `optionsKey` points a select at an `options` list; `repeatable` marks a field that is one column of a repeated row (a step / dimension / measure); `visibleWhen` gates a field to a sub-case. Charts that share a builder (Input Box + Slider) point at a shared block by name (string alias).",
  "layoutSteps": {
    "WATERFALL": {
      "label": "Waterfall bridge",
      "sections": [
        {
          "id": "config",
          "title": "Chart configuration",
          "hint": "Pick the layout, name the chart, and choose the datasets to bridge across.",
          "fields": [
            {
              "field": "layoutType",
              "label": "Chart layout",
              "control": "select",
              "optionsKey": "layoutTypes",
              "required": true
            },
            {
              "field": "title",
              "label": "Title",
              "control": "text",
              "required": true
            },
            {
              "field": "datasets",
              "label": "Datasets",
              "control": "multiselect",
              "hint": "One or more entities to bridge across.",
              "required": true
            }
          ]
        },
        {
          "id": "steps",
          "title": "Bridge steps",
          "hint": "Add a Start anchor, then Change/Total steps to build the bridge.",
          "fields": [
            {
              "field": "stepType",
              "label": "Step type",
              "control": "select",
              "optionsKey": "stepTypes",
              "repeatable": true,
              "required": true
            },
            {
              "field": "label",
              "label": "Display label",
              "control": "text",
              "repeatable": true
            },
            {
              "field": "dataset",
              "label": "Target dataset",
              "control": "select",
              "repeatable": true,
              "visibleWhen": "stepType:START|CHANGE"
            },
            {
              "field": "field",
              "label": "Field / column",
              "control": "select",
              "repeatable": true,
              "visibleWhen": "stepType:START|CHANGE"
            },
            {
              "field": "aggregation",
              "label": "Aggregation",
              "control": "select",
              "optionsKey": "layoutAggregations",
              "repeatable": true,
              "visibleWhen": "stepType:START|CHANGE"
            },
            {
              "field": "sign",
              "label": "Impact direction",
              "control": "select",
              "optionsKey": "signOptions",
              "repeatable": true,
              "visibleWhen": "stepType:CHANGE"
            },
            {
              "field": "formula",
              "label": "Calculation logic / formula",
              "control": "text",
              "repeatable": true,
              "visibleWhen": "stepType:START|CHANGE|TOTAL"
            }
          ]
        }
      ]
    },
    "DRILL_DOWN_TABLE": {
      "label": "Drill-down table",
      "sections": [
        {
          "id": "config",
          "title": "Chart configuration",
          "hint": "Pick the layout, name the table, and choose one dataset.",
          "fields": [
            {
              "field": "layoutType",
              "label": "Chart layout",
              "control": "select",
              "optionsKey": "layoutTypes",
              "required": true
            },
            {
              "field": "title",
              "label": "Title",
              "control": "text",
              "required": true
            },
            {
              "field": "dataset",
              "label": "Dataset",
              "control": "select",
              "hint": "The single entity every level and measure reads from.",
              "required": true
            }
          ]
        },
        {
          "id": "dimensions",
          "title": "Hierarchy dimensions",
          "hint": "Order the levels top-down — Level 1 is the outermost group.",
          "fields": [
            {
              "field": "field",
              "label": "Group-by column",
              "control": "select",
              "repeatable": true,
              "required": true
            },
            {
              "field": "label",
              "label": "Display name",
              "control": "text",
              "repeatable": true
            },
            {
              "field": "valueOrder",
              "label": "Value order (optional)",
              "control": "text",
              "repeatable": true,
              "hint": "Comma-separated list fixing the order this level's values appear in. Leave blank to keep the backend's default order."
            },
            {
              "field": "editable",
              "label": "Editable labels",
              "control": "checkbox",
              "repeatable": true
            },
            {
              "field": "editor",
              "label": "Edit control",
              "control": "select",
              "repeatable": true,
              "hint": "Shown once Editable labels is on. Input = free-text rename; Dropdown = pick from a list of custom values (they need not exist in the data) and/or the labels already in the table."
            },
            {
              "field": "dropdownOptions",
              "label": "Dropdown values",
              "control": "text",
              "repeatable": true,
              "hint": "Comma-separated custom values for the dropdown editor."
            },
            {
              "field": "dropdownFromData",
              "label": "Also list values from the table",
              "control": "checkbox",
              "repeatable": true
            }
          ]
        },
        {
          "id": "measures",
          "title": "Measures",
          "hint": "Value columns shown and rolled up at every level.",
          "fields": [
            {
              "field": "field",
              "label": "Value column",
              "control": "select",
              "repeatable": true,
              "required": true
            },
            {
              "field": "label",
              "label": "Measure label",
              "control": "text",
              "repeatable": true
            },
            {
              "field": "aggregation",
              "label": "Aggregation",
              "control": "select",
              "optionsKey": "measureAggregations",
              "repeatable": true
            },
            {
              "field": "rollUpStrategy",
              "label": "Roll-up strategy",
              "control": "select",
              "optionsKey": "rollUpStrategies",
              "repeatable": true
            },
            {
              "field": "total",
              "label": "Show in Grand Total",
              "control": "checkbox",
              "repeatable": true
            },
            {
              "field": "editable",
              "label": "Editable values",
              "control": "checkbox",
              "repeatable": true
            },
            {
              "field": "editor",
              "label": "Edit control",
              "control": "select",
              "repeatable": true,
              "hint": "Shown once Editable values is on. Input = number / text input; Dropdown = pick from a list of custom values (they need not exist in the data) and/or the values the column already holds."
            },
            {
              "field": "dropdownOptions",
              "label": "Dropdown values",
              "control": "text",
              "repeatable": true,
              "hint": "Comma-separated custom values for the dropdown editor (numeric for a Number measure)."
            },
            {
              "field": "dropdownFromData",
              "label": "Also list values from the table",
              "control": "checkbox",
              "repeatable": true
            },
            {
              "field": "editableLevels",
              "label": "Editable on levels",
              "control": "select",
              "repeatable": true,
              "hint": "Shown once Editable values is on. Multi-select of the tree levels whose rows get the input / dropdown (Level 1 = outermost, last = leaf rows). Empty = default: a Text measure edits on every level, a Number measure on leaf rows only."
            }
          ]
        }
      ]
    },
    "HORIZONTAL_BAR_CHART": {
      "label": "Horizontal bar chart",
      "sections": [
        {
          "id": "config",
          "title": "Chart configuration",
          "hint": "Pick the layout, name the chart, and choose one dataset.",
          "fields": [
            {
              "field": "layoutType",
              "label": "Chart layout",
              "control": "select",
              "optionsKey": "layoutTypes",
              "required": true
            },
            {
              "field": "title",
              "label": "Title",
              "control": "text",
              "required": true
            },
            {
              "field": "dataset",
              "label": "Dataset",
              "control": "select",
              "required": true
            }
          ]
        },
        {
          "id": "axes",
          "title": "Bar axes",
          "hint": "One group-by field on the Y-axis and one formula-driven value on the X-axis.",
          "fields": [
            {
              "field": "groupByField",
              "label": "Y-axis — group by",
              "control": "select",
              "required": true
            },
            {
              "field": "groupByLabel",
              "label": "Y-axis display name",
              "control": "text"
            },
            {
              "field": "valueLabel",
              "label": "X-axis value label",
              "control": "text"
            },
            {
              "field": "valueFormula",
              "label": "X-axis value formula",
              "control": "text",
              "required": true
            }
          ]
        }
      ]
    },
    "INPUT_CONTROL": {
      "label": "Input control",
      "sections": [
        {
          "id": "input",
          "title": "Input settings",
          "hint": "This control feeds its formula/measure value into the target chart(s) or other input(s) selected below.",
          "fields": [
            {
              "field": "title",
              "label": "Title",
              "control": "text",
              "required": true
            },
            {
              "field": "formula",
              "label": "Formula / measure",
              "control": "text",
              "required": true
            },
            {
              "field": "targetCharts",
              "label": "Target chart(s) / input(s)",
              "control": "multiselect",
              "optionsKey": "targetCharts",
              "required": true
            },
            {
              "field": "min",
              "label": "Min",
              "control": "number",
              "visibleWhen": "layout:SLIDER"
            },
            {
              "field": "max",
              "label": "Max",
              "control": "number",
              "visibleWhen": "layout:SLIDER"
            },
            {
              "field": "step",
              "label": "Step",
              "control": "number",
              "visibleWhen": "layout:SLIDER"
            },
            {
              "field": "defaultValue",
              "label": "Default value",
              "control": "number"
            }
          ]
        }
      ]
    },
    "KPI": {
      "label": "KPI card",
      "sections": [
        {
          "id": "kpi",
          "title": "KPI card",
          "hint": "Pick one column and how to aggregate it (Sum / Distinct Count / …) into a single headline value.",
          "fields": [
            {
              "field": "layoutType",
              "label": "Chart layout",
              "control": "select",
              "optionsKey": "layoutTypes",
              "required": true
            },
            {
              "field": "title",
              "label": "Title",
              "control": "text",
              "required": true
            },
            {
              "field": "dataset",
              "label": "Dataset",
              "control": "select",
              "required": true
            },
            {
              "field": "field",
              "label": "Column",
              "control": "select",
              "required": true
            },
            {
              "field": "aggregation",
              "label": "Aggregation",
              "control": "select",
              "optionsKey": "kpiAggregations",
              "required": true
            },
            {
              "field": "formula",
              "label": "Formula (optional)",
              "control": "text",
              "hint": "Custom calculation instead of a single column, e.g. [price] * [qty]. Leave blank to use Column + Aggregation."
            }
          ]
        }
      ]
    },
    "DROPDOWN": {
      "label": "Dropdown",
      "sections": [
        {
          "id": "config",
          "title": "Dropdown configuration",
          "hint": "Name the dropdown and choose the dataset that supplies its options.",
          "fields": [
            {
              "field": "layoutType",
              "label": "Layout",
              "control": "select",
              "optionsKey": "layoutTypes",
              "required": true
            },
            {
              "field": "title",
              "label": "Title",
              "control": "text",
              "required": true
            },
            {
              "field": "dataset",
              "label": "Dataset",
              "control": "select",
              "required": true
            }
          ]
        },
        {
          "id": "dropdown",
          "title": "Dropdown settings",
          "hint": "Choose the field whose distinct values become dropdown options and select the chart(s) or input(s) it controls.",
          "fields": [
            {
              "field": "field",
              "label": "Option field",
              "control": "select",
              "required": true
            },
            {
              "field": "displayLabel",
              "label": "Display label",
              "control": "text"
            },
            {
              "field": "staticOptions",
              "label": "Options (comma-separated)",
              "control": "text",
              "hint": "Optional fixed option list (e.g. Approve, Reject, Hold). When filled, these replace the option field's dataset values; the option field is still the column the targets are filtered on."
            },
            {
              "field": "displayMode",
              "label": "Display as",
              "control": "select",
              "optionsKey": "dropdownDisplayModes",
              "hint": "Dropdown shows a select control; Buttons/Tiles render every option as an always-visible filter button."
            },
            {
              "field": "targetCharts",
              "label": "Target chart(s) / input(s)",
              "control": "multiselect",
              "optionsKey": "targetCharts",
              "required": true
            },
            {
              "field": "isMultiSelect",
              "label": "Allow multiple selections",
              "control": "checkbox"
            },
            {
              "field": "showAllOption",
              "label": "Show All option",
              "control": "checkbox",
              "hint": "Adds a synthetic All choice that clears the dropdown filter. Off means only backend response options are shown."
            },
            {
              "field": "defaultValue",
              "label": "Default value",
              "control": "text"
            }
          ]
        },
        {
          "id": "dropdownAdvanced",
          "title": "Advanced",
          "hint": "Control how dropdown options are ordered before the widget is saved and published.",
          "fields": [
            {
              "field": "optionOrderMode",
              "label": "Option order",
              "control": "select",
              "optionsKey": "dropdownOptionOrderModes"
            },
            {
              "field": "customOptionOrder",
              "label": "Custom option order",
              "control": "text",
              "hint": "Comma-separated values. Listed values appear first; missing response values stay after them."
            }
          ]
        }
      ]
    },
    "TABLE_MATRIX": {
      "label": "Table & matrix",
      "sections": [
        {
          "id": "config",
          "title": "Chart configuration",
          "hint": "Pick the layout, name the table, and choose one dataset.",
          "fields": [
            {
              "field": "layoutType",
              "label": "Chart layout",
              "control": "select",
              "optionsKey": "layoutTypes",
              "required": true
            },
            {
              "field": "title",
              "label": "Title",
              "control": "text",
              "required": true
            },
            {
              "field": "dataset",
              "label": "Dataset",
              "control": "select",
              "required": true
            }
          ]
        },
        {
          "id": "tableMatrix",
          "title": "Table & matrix",
          "hint": "Choose a table type, then its columns / hierarchy.",
          "fields": [
            {
              "field": "tableType",
              "label": "Table type",
              "control": "select",
              "optionsKey": "tableTypes",
              "required": true
            },
            {
              "field": "columns",
              "label": "Columns",
              "control": "select",
              "visibleWhenType": [
                "normal",
                "editable"
              ],
              "hint": "One row per column — each picks its own dataset (defaults to the primary one), column and header display name, so a table can mix columns from different datasets. Leave empty to show every column of the primary dataset."
            },
            {
              "field": "groupBy",
              "label": "Group rows by",
              "control": "select",
              "visibleWhenType": [
                "normal"
              ]
            },
            {
              "field": "aggregation",
              "label": "Aggregation",
              "control": "select",
              "optionsKey": "tmAggregations",
              "visibleWhenType": [
                "normal"
              ]
            },
            {
              "field": "dimensions",
              "label": "Hierarchy dimensions",
              "control": "select",
              "visibleWhenType": [
                "drilldown"
              ]
            },
            {
              "field": "measures",
              "label": "Measures",
              "control": "select",
              "visibleWhenType": [
                "drilldown"
              ]
            }
          ]
        }
      ]
    },
    "FILE_UPLOAD": {
      "label": "File upload",
      "sections": [
        {
          "id": "config",
          "title": "File upload configuration",
          "hint": "Name the uploader and choose which chart(s)/table(s) the uploaded file updates.",
          "fields": [
            {
              "field": "layoutType",
              "label": "Layout",
              "control": "select",
              "optionsKey": "layoutTypes",
              "required": true
            },
            {
              "field": "title",
              "label": "Title",
              "control": "text",
              "required": true
            }
          ]
        },
        {
          "id": "upload",
          "title": "Upload settings",
          "hint": "The picked file is POSTed to the compute API tagged with the target(s); the response re-renders those charts/tables.",
          "fields": [
            {
              "field": "targetCharts",
              "label": "Target chart(s) / table(s)",
              "control": "multiselect",
              "optionsKey": "targetCharts",
              "required": true
            },
            {
              "field": "buttonLabel",
              "label": "Upload button label",
              "control": "text"
            },
            {
              "field": "accept",
              "label": "Accepted file types",
              "control": "text"
            }
          ]
        }
      ]
    },
    "INPUT_BOX": "INPUT_CONTROL",
    "SLIDER": "INPUT_CONTROL"
  },
  "options": {
    "// shared": "Only truly cross-cutting config lives in the shell. layoutTypes (the master list), chartCatalogue + capabilityRegistry (organise ALL types), numberFormats + the shared formatControls (apply to every chart tile). Everything chart-specific moved to charts/<chart>.json.",
    "layoutTypes": [
      {
        "label": "Waterfall",
        "value": "WATERFALL"
      },
      {
        "label": "Drill-Down Table",
        "value": "DRILL_DOWN_TABLE"
      },
      {
        "label": "Bar Charts",
        "value": "BAR"
      },
      {
        "label": "Line & Area",
        "value": "LINE_AREA"
      },
      {
        "label": "Scatter & Bubble",
        "value": "SCATTER_BUBBLE"
      },
      {
        "label": "Pie & Composition",
        "value": "PIE_COMPOSITION"
      },
      {
        "label": "Table & Matrix",
        "value": "TABLE_MATRIX"
      },
      {
        "label": "Kpi Card",
        "value": "KPI"
      },
      {
        "label": "Input Box",
        "value": "INPUT_BOX"
      },
      {
        "label": "Slider",
        "value": "SLIDER"
      },
      {
        "label": "Dropdown",
        "value": "DROPDOWN"
      },
      {
        "label": "File Upload",
        "value": "FILE_UPLOAD"
      },
      {
        "label": "Popup",
        "value": "POPUP"
      }
    ],
    "// dropdownDisplayModes": "How a DROPDOWN input renders its options: the classic select, or every option as an always-visible filter button/tile (same filtering behavior, different surface).",
    "dropdownDisplayModes": [
      {
        "label": "Dropdown",
        "value": "dropdown"
      },
      {
        "label": "Buttons",
        "value": "buttons"
      },
      {
        "label": "Tiles",
        "value": "tiles"
      }
    ],
    "dropdownOptionOrderModes": [
      {
        "label": "Backend response order",
        "value": "response"
      },
      {
        "label": "Ascending",
        "value": "asc"
      },
      {
        "label": "Descending",
        "value": "desc"
      },
      {
        "label": "Custom",
        "value": "custom"
      }
    ],
    "// chartCatalogue": "LAYER 1 — Chart Catalogue. Groups the layoutTypes above under categories so the builder shows a Category → Type picker. `types` reference layoutTypes values.",
    "chartCatalogue": [
      {
        "id": "bar-column",
        "label": "Bar & Column",
        "icon": "bar_chart",
        "description": "Simple/Grouped/Stacked/100%/Clustered bars & columns, combos, dual axis.",
        "types": [
          "BAR"
        ]
      },
      {
        "id": "line-area",
        "label": "Line & Area",
        "icon": "show_chart",
        "description": "Line, Multi-Line, Step, Spline; Area, Stacked, 100%; trend/forecast/moving-average, dual axis.",
        "types": [
          "LINE_AREA"
        ]
      },
      {
        "id": "scatter-bubble",
        "label": "Scatter & Bubble",
        "icon": "scatter_plot",
        "description": "Scatter, Multi Scatter, Bubble, Quadrant — X/Y with optional size & color.",
        "types": [
          "SCATTER_BUBBLE"
        ]
      },
      {
        "id": "pie-composition",
        "label": "Pie & Composition",
        "icon": "pie_chart",
        "description": "Pie, Donut, Semi Donut; Sunburst, Treemap, Nested Donut; Radial / Circular / Ring progress.",
        "types": [
          "PIE_COMPOSITION"
        ]
      },
      {
        "id": "flow-financial",
        "label": "Flow & Financial",
        "icon": "waterfall_chart",
        "description": "Bridge / waterfall analyses.",
        "types": [
          "WATERFALL"
        ]
      },
      {
        "id": "hierarchy",
        "label": "Hierarchy & Tables",
        "icon": "account_tree",
        "description": "Normal, editable, drill-down and nested tables (each a Table type of Table & Matrix).",
        "types": [
          "TABLE_MATRIX"
        ]
      },
      {
        "id": "kpi",
        "label": "KPI & Single Value",
        "icon": "speed",
        "description": "Headline single-value cards.",
        "types": [
          "KPI"
        ]
      },
      {
        "id": "inputs",
        "label": "Inputs & Controls",
        "icon": "tune",
        "description": "Interactive inputs that drive other charts.",
        "types": [
          "INPUT_BOX",
          "SLIDER",
          "DROPDOWN",
          "FILE_UPLOAD",
          "POPUP"
        ]
      }
    ],
    "// capabilityRegistry": "LAYER 2 — Capability Registry. Per layoutType, what that chart supports. `sections` lists the Configuration accordions the chart exposes; capability flags gate specific controls/features. Unlisted charts fall back to their built-in defaults.",
    "capabilityRegistry": {
      "BAR": {
        "singleXAxis": true,
        "dualXAxis": true,
        "dualYAxis": true,
        "singleYAxis": true,
        "hierarchicalXAxis": true,
        "singleMeasure": true,
        "multipleMeasures": true,
        "secondaryMeasure": true,
        "singleCategory": true,
        "series": true,
        "legend": true,
        "referenceLine": true,
        "targetLine": true,
        "drillDown": false,
        "crossFilter": true,
        "crossHighlight": true,
        "zoom": true,
        "pan": true,
        "colors": true,
        "labels": true,
        "tooltip": true,
        "grid": true,
        "theme": true,
        "sections": [
          "Title",
          "Axis",
          "Legend",
          "Labels",
          "Tooltip",
          "Formatting",
          "Interaction",
          "Advanced"
        ]
      },
      "LINE_AREA": {
        "singleXAxis": true,
        "singleYAxis": true,
        "dualYAxis": true,
        "hierarchicalXAxis": true,
        "singleMeasure": true,
        "multipleMeasures": true,
        "secondaryMeasure": true,
        "singleCategory": true,
        "series": true,
        "legend": true,
        "referenceLine": true,
        "targetLine": true,
        "trendLine": true,
        "forecast": true,
        "movingAverage": true,
        "drillDown": false,
        "crossFilter": true,
        "crossHighlight": true,
        "zoom": true,
        "pan": true,
        "colors": true,
        "labels": true,
        "tooltip": true,
        "grid": true,
        "theme": true,
        "sections": [
          "Title",
          "Axis",
          "Legend",
          "Labels",
          "Tooltip",
          "Formatting",
          "Analytics",
          "Interaction",
          "Advanced"
        ]
      },
      "SCATTER_BUBBLE": {
        "singleXAxis": true,
        "dualXAxis": true,
        "singleYAxis": true,
        "dualYAxis": true,
        "singleMeasure": true,
        "multipleMeasures": true,
        "secondaryMeasure": true,
        "singleCategory": true,
        "series": true,
        "legend": true,
        "referenceLine": true,
        "trendLine": true,
        "drillDown": false,
        "crossFilter": true,
        "crossHighlight": true,
        "zoom": true,
        "pan": true,
        "colors": true,
        "labels": true,
        "tooltip": true,
        "grid": true,
        "theme": true,
        "sections": [
          "Title",
          "Axis",
          "Legend",
          "Labels",
          "Tooltip",
          "Formatting",
          "Interaction",
          "Advanced"
        ]
      },
      "PIE_COMPOSITION": {
        "singleMeasure": true,
        "singleCategory": true,
        "series": false,
        "legend": true,
        "drillDown": true,
        "crossFilter": true,
        "crossHighlight": true,
        "colors": true,
        "labels": true,
        "tooltip": true,
        "theme": true,
        "sections": [
          "Title",
          "Legend",
          "Labels",
          "Tooltip",
          "Formatting",
          "Progress",
          "Interaction",
          "Advanced"
        ]
      },
      "HORIZONTAL_BAR_CHART": {
        "singleYAxis": true,
        "singleMeasure": true,
        "singleCategory": true,
        "colors": true,
        "labels": true,
        "tooltip": true,
        "sections": [
          "Formatting"
        ]
      },
      "WATERFALL": {
        "singleXAxis": true,
        "singleYAxis": true,
        "calculatedMeasure": true,
        "colors": true,
        "labels": true,
        "tooltip": true,
        "legend": true,
        "zoom": true,
        "pan": true,
        "sections": [
          "Title",
          "Axis",
          "Legend",
          "Labels",
          "Tooltip",
          "Formatting",
          "Interaction",
          "Advanced"
        ]
      },
      "DRILL_DOWN_TABLE": {
        "multipleCategories": true,
        "multipleMeasures": true,
        "hierarchicalXAxis": true,
        "drillDown": true,
        "crossFilter": true,
        "sections": [
          "Formatting",
          "Filters"
        ]
      },
      "NESTED_TABLE": {
        "multipleCategories": true,
        "multipleMeasures": true,
        "drillDown": true,
        "crossFilter": true,
        "sections": [
          "Formatting",
          "Filters"
        ]
      },
      "TABLE_MATRIX": {
        "multipleCategories": true,
        "multipleMeasures": true,
        "drillDown": true,
        "crossFilter": true,
        "colors": true,
        "sections": [
          "Formatting",
          "Totals",
          "Columns",
          "Filters",
          "Interaction",
          "Editable", "CRUD", "Workflow", "Drill-Down", "Title"]
      },
      "KPI": {
        "singleMeasure": true,
        "benchmark": true,
        "colors": true,
        "tooltip": false,
        "sections": [
          "Formatting"
        ]
      },
      "INPUT_BOX": {
        "sections": [
          "Title"
        ]
      },
      "SLIDER": {
        "sections": [
          "Title"
        ]
      },
      "DROPDOWN": {
        "sections": [
          "Formatting"
        ]
      },
      "FILE_UPLOAD": {
        "sections": [
          "Title"
        ]
      }
    },
    "// targetCharts": "Removed — an input control's targets are now built dynamically from EVERY OTHER tile currently on the dashboard, charts AND other input controls (see DvmLayoutBuilderComponent.targetCharts).",
    "// enableFormulaReferences": "Toggles the 'Reference' UI under a formula field, PER chart/component layout type — covers an input control's per-target formula (scoped by the TARGET's type) and a chart's own formula (KPI / horizontal bar). Set a type to false to hide it for that type only; a missing key (or the whole block) defaults to shown.",
    "enableFormulaReferences": {
      "KPI": true,
      "BAR": true,
      "HORIZONTAL_BAR_CHART": true,
      "WATERFALL": true,
      "INPUT_BOX": true,
      "SLIDER": true,
      "TABLE_MATRIX": false,
      "FILE_UPLOAD": false
    },
    "// fileUploadDefaults": "Defaults for the standalone File Upload tile (Chart layout → File Upload). The picked file POSTs as multipart FormData to the compute API tagged with the target componentIds; the response re-renders those targets.",
    "fileUploadDefaults": {
      "buttonLabel": "Upload file",
      "accept": ".xlsx,.xls,.csv"
    },
    "xAxisLabelRotations": [
      {
        "label": "Tilted (30 degrees)",
        "value": "30"
      },
      {
        "label": "Straight (0 degrees)",
        "value": "0"
      }
    ],
    "// numberFormats": "Shared across all chart tiles' Format popup (the `numberFormat` control has no appliesTo). Stays in the shell.",
    "numberFormats": [
      {
        "label": "Default",
        "value": "NONE"
      },
      {
        "label": "Commas (1,234)",
        "value": "THOUSANDS"
      },
      {
        "label": "Auto scale (K/M/B)",
        "value": "COMPACT"
      },
      {
        "label": "Thousands (K)",
        "value": "SCALE_THOUSANDS"
      },
      {
        "label": "Millions (M)",
        "value": "MILLIONS"
      },
      {
        "label": "Billions (B)",
        "value": "BILLIONS"
      },
      {
        "label": "Percent (12%)",
        "value": "PERCENT"
      }
    ],
    "decimalOptions": [
      {
        "label": "0",
        "value": "0"
      },
      {
        "label": "1",
        "value": "1"
      },
      {
        "label": "2",
        "value": "2"
      }
    ],
    "titleAlignments": [
      { "label": "Left", "value": "left" },
      { "label": "Center", "value": "center" },
      { "label": "Right", "value": "right" }
    ],
    "// fontFamilies": "Shared font stacks for the Font family format control. Values are CSS/canvas font-family strings — usable both as a CSS var (HTML widgets) and as ECharts textStyle.fontFamily (canvas charts). Empty value = keep the theme default.",
    "fontFamilies": [
      {"label": "Default", "value": ""},
      {"label": "ABeeZee", "value": "ABeeZee, sans-serif"},
      {"label": "Abel", "value": "Abel, sans-serif"},
      {"label": "Abhaya Libre", "value": "'Abhaya Libre', serif"},
      {"label": "Aboreto", "value": "Aboreto, sans-serif"},
      {"label": "Abril Fatface", "value": "'Abril Fatface', sans-serif"},
      {"label": "Abyssinica SIL", "value": "'Abyssinica SIL', serif"},
      {"label": "Aclonica", "value": "Aclonica, sans-serif"},
      {"label": "Acme", "value": "Acme, sans-serif"},
      {"label": "Actor", "value": "Actor, sans-serif"},
      {"label": "Adamina", "value": "Adamina, serif"},
      {"label": "ADLaM Display", "value": "'ADLaM Display', sans-serif"},
      {"label": "Advent Pro", "value": "'Advent Pro', sans-serif"},
      {"label": "Afacad", "value": "Afacad, sans-serif"},
      {"label": "Afacad Flux", "value": "'Afacad Flux', sans-serif"},
      {"label": "Agbalumo", "value": "Agbalumo, sans-serif"},
      {"label": "Agdasima", "value": "Agdasima, sans-serif"},
      {"label": "Agu Display", "value": "'Agu Display', sans-serif"},
      {"label": "Aguafina Script", "value": "'Aguafina Script', cursive"},
      {"label": "Akatab", "value": "Akatab, sans-serif"},
      {"label": "Akaya Kanadaka", "value": "'Akaya Kanadaka', sans-serif"},
      {"label": "Akaya Telivigala", "value": "'Akaya Telivigala', sans-serif"},
      {"label": "Akronim", "value": "Akronim, sans-serif"},
      {"label": "Akshar", "value": "Akshar, sans-serif"},
      {"label": "Akt", "value": "Akt, sans-serif"},
      {"label": "Aladin", "value": "Aladin, sans-serif"},
      {"label": "Alan Sans", "value": "'Alan Sans', sans-serif"},
      {"label": "Alata", "value": "Alata, sans-serif"},
      {"label": "Alatsi", "value": "Alatsi, sans-serif"},
      {"label": "Albert Sans", "value": "'Albert Sans', sans-serif"},
      {"label": "Aldrich", "value": "Aldrich, sans-serif"},
      {"label": "Alef", "value": "Alef, sans-serif"},
      {"label": "Alegreya", "value": "Alegreya, serif"},
      {"label": "Alegreya Sans", "value": "'Alegreya Sans', sans-serif"},
      {"label": "Alegreya Sans SC", "value": "'Alegreya Sans SC', sans-serif"},
      {"label": "Alegreya SC", "value": "'Alegreya SC', serif"},
      {"label": "Aleo", "value": "Aleo, serif"},
      {"label": "Alex Brush", "value": "'Alex Brush', cursive"},
      {"label": "Alexandria", "value": "Alexandria, sans-serif"},
      {"label": "Alfa Slab One", "value": "'Alfa Slab One', sans-serif"},
      {"label": "Alice", "value": "Alice, serif"},
      {"label": "Alien Block", "value": "'Alien Block', sans-serif"},
      {"label": "Alike", "value": "Alike, serif"},
      {"label": "Alike Angular", "value": "'Alike Angular', serif"},
      {"label": "Alkalami", "value": "Alkalami, serif"},
      {"label": "Alkatra", "value": "Alkatra, sans-serif"},
      {"label": "Allan", "value": "Allan, sans-serif"},
      {"label": "Allerta", "value": "Allerta, sans-serif"},
      {"label": "Allerta Stencil", "value": "'Allerta Stencil', sans-serif"},
      {"label": "Allison", "value": "Allison, cursive"},
      {"label": "Allkin", "value": "Allkin, sans-serif"},
      {"label": "Allura", "value": "Allura, cursive"},
      {"label": "Almarai", "value": "Almarai, sans-serif"},
      {"label": "Almendra", "value": "Almendra, serif"},
      {"label": "Almendra Display", "value": "'Almendra Display', sans-serif"},
      {"label": "Almendra SC", "value": "'Almendra SC', serif"},
      {"label": "Alumni Sans", "value": "'Alumni Sans', sans-serif"},
      {"label": "Alumni Sans Collegiate One", "value": "'Alumni Sans Collegiate One', sans-serif"},
      {"label": "Alumni Sans Inline One", "value": "'Alumni Sans Inline One', sans-serif"},
      {"label": "Alumni Sans Pinstripe", "value": "'Alumni Sans Pinstripe', sans-serif"},
      {"label": "Alumni Sans SC", "value": "'Alumni Sans SC', sans-serif"},
      {"label": "Alyamama", "value": "Alyamama, serif"},
      {"label": "Amarante", "value": "Amarante, sans-serif"},
      {"label": "Amaranth", "value": "Amaranth, sans-serif"},
      {"label": "Amarna", "value": "Amarna, sans-serif"},
      {"label": "Amatic SC", "value": "'Amatic SC', cursive"},
      {"label": "Amethysta", "value": "Amethysta, serif"},
      {"label": "Amiko", "value": "Amiko, sans-serif"},
      {"label": "Amiri", "value": "Amiri, serif"},
      {"label": "Amiri Quran", "value": "'Amiri Quran', serif"},
      {"label": "Amita", "value": "Amita, cursive"},
      {"label": "Anaheim", "value": "Anaheim, sans-serif"},
      {"label": "Ancizar Sans", "value": "'Ancizar Sans', sans-serif"},
      {"label": "Ancizar Serif", "value": "'Ancizar Serif', serif"},
      {"label": "Andada Pro", "value": "'Andada Pro', serif"},
      {"label": "Andika", "value": "Andika, sans-serif"},
      {"label": "Anek Bangla", "value": "'Anek Bangla', sans-serif"},
      {"label": "Anek Devanagari", "value": "'Anek Devanagari', sans-serif"},
      {"label": "Anek Gujarati", "value": "'Anek Gujarati', sans-serif"},
      {"label": "Anek Gurmukhi", "value": "'Anek Gurmukhi', sans-serif"},
      {"label": "Anek Kannada", "value": "'Anek Kannada', sans-serif"},
      {"label": "Anek Latin", "value": "'Anek Latin', sans-serif"},
      {"label": "Anek Malayalam", "value": "'Anek Malayalam', sans-serif"},
      {"label": "Anek Odia", "value": "'Anek Odia', sans-serif"},
      {"label": "Anek Tamil", "value": "'Anek Tamil', sans-serif"},
      {"label": "Anek Telugu", "value": "'Anek Telugu', sans-serif"},
      {"label": "Angkor", "value": "Angkor, sans-serif"},
      {"label": "Annapurna SIL", "value": "'Annapurna SIL', serif"},
      {"label": "Annie Use Your Telescope", "value": "'Annie Use Your Telescope', cursive"},
      {"label": "Anonymous Pro", "value": "'Anonymous Pro', monospace"},
      {"label": "Anta", "value": "Anta, sans-serif"},
      {"label": "Antic", "value": "Antic, sans-serif"},
      {"label": "Antic Didone", "value": "'Antic Didone', serif"},
      {"label": "Antic Slab", "value": "'Antic Slab', serif"},
      {"label": "Anton", "value": "Anton, sans-serif"},
      {"label": "Anton SC", "value": "'Anton SC', sans-serif"},
      {"label": "Antonio", "value": "Antonio, sans-serif"},
      {"label": "Anuphan", "value": "Anuphan, sans-serif"},
      {"label": "Anybody", "value": "Anybody, sans-serif"},
      {"label": "Aoboshi One", "value": "'Aoboshi One', serif"},
      {"label": "AR One Sans", "value": "'AR One Sans', sans-serif"},
      {"label": "Arapey", "value": "Arapey, serif"},
      {"label": "Arbutus", "value": "Arbutus, serif"},
      {"label": "Arbutus Slab", "value": "'Arbutus Slab', serif"},
      {"label": "Architects Daughter", "value": "'Architects Daughter', cursive"},
      {"label": "Archivo", "value": "Archivo, sans-serif"},
      {"label": "Archivo Black", "value": "'Archivo Black', sans-serif"},
      {"label": "Archivo Narrow", "value": "'Archivo Narrow', sans-serif"},
      {"label": "Are You Serious", "value": "'Are You Serious', cursive"},
      {"label": "Aref Ruqaa", "value": "'Aref Ruqaa', serif"},
      {"label": "Aref Ruqaa Ink", "value": "'Aref Ruqaa Ink', serif"},
      {"label": "Arial", "value": "Arial, Helvetica, sans-serif"},
      {"label": "Arima", "value": "Arima, sans-serif"},
      {"label": "Arimo", "value": "Arimo, sans-serif"},
      {"label": "Arizonia", "value": "Arizonia, cursive"},
      {"label": "Armata", "value": "Armata, sans-serif"},
      {"label": "Arsenal", "value": "Arsenal, sans-serif"},
      {"label": "Arsenal SC", "value": "'Arsenal SC', sans-serif"},
      {"label": "Artifika", "value": "Artifika, serif"},
      {"label": "Arvo", "value": "Arvo, serif"},
      {"label": "Arya", "value": "Arya, sans-serif"},
      {"label": "Asap", "value": "Asap, sans-serif"},
      {"label": "Asap Condensed", "value": "'Asap Condensed', sans-serif"},
      {"label": "Asap Sharp", "value": "'Asap Sharp', sans-serif"},
      {"label": "Asar", "value": "Asar, serif"},
      {"label": "Asimovian", "value": "Asimovian, sans-serif"},
      {"label": "Asset", "value": "Asset, sans-serif"},
      {"label": "Assistant", "value": "Assistant, sans-serif"},
      {"label": "Asta Sans", "value": "'Asta Sans', sans-serif"},
      {"label": "Astloch", "value": "Astloch, sans-serif"},
      {"label": "Asul", "value": "Asul, serif"},
      {"label": "Athiti", "value": "Athiti, sans-serif"},
      {"label": "Atkinson Hyperlegible", "value": "'Atkinson Hyperlegible', sans-serif"},
      {"label": "Atkinson Hyperlegible Mono", "value": "'Atkinson Hyperlegible Mono', sans-serif"},
      {"label": "Atkinson Hyperlegible Next", "value": "'Atkinson Hyperlegible Next', sans-serif"},
      {"label": "Atma", "value": "Atma, sans-serif"},
      {"label": "Atomic Age", "value": "'Atomic Age', sans-serif"},
      {"label": "Aubrey", "value": "Aubrey, sans-serif"},
      {"label": "Audiowide", "value": "Audiowide, sans-serif"},
      {"label": "Autour One", "value": "'Autour One', sans-serif"},
      {"label": "Average", "value": "Average, serif"},
      {"label": "Average Sans", "value": "'Average Sans', sans-serif"},
      {"label": "Averia Gruesa Libre", "value": "'Averia Gruesa Libre', sans-serif"},
      {"label": "Averia Libre", "value": "'Averia Libre', sans-serif"},
      {"label": "Averia Sans Libre", "value": "'Averia Sans Libre', sans-serif"},
      {"label": "Averia Serif Libre", "value": "'Averia Serif Libre', sans-serif"},
      {"label": "Azeret Mono", "value": "'Azeret Mono', monospace"},
      {"label": "B612", "value": "'B612', sans-serif"},
      {"label": "B612 Mono", "value": "'B612 Mono', monospace"},
      {"label": "Babylonica", "value": "Babylonica, cursive"},
      {"label": "Bacasime Antique", "value": "'Bacasime Antique', serif"},
      {"label": "Bad Script", "value": "'Bad Script', cursive"},
      {"label": "Badeen Display", "value": "'Badeen Display', sans-serif"},
      {"label": "Bagel Fat One", "value": "'Bagel Fat One', sans-serif"},
      {"label": "Bahiana", "value": "Bahiana, sans-serif"},
      {"label": "Bahianita", "value": "Bahianita, sans-serif"},
      {"label": "Bai Jamjuree", "value": "'Bai Jamjuree', sans-serif"},
      {"label": "Bakbak One", "value": "'Bakbak One', sans-serif"},
      {"label": "Ballet", "value": "Ballet, cursive"},
      {"label": "Baloo 2", "value": "'Baloo 2', sans-serif"},
      {"label": "Baloo Bhai 2", "value": "'Baloo Bhai 2', sans-serif"},
      {"label": "Baloo Bhaijaan 2", "value": "'Baloo Bhaijaan 2', sans-serif"},
      {"label": "Baloo Bhaina 2", "value": "'Baloo Bhaina 2', sans-serif"},
      {"label": "Baloo Chettan 2", "value": "'Baloo Chettan 2', sans-serif"},
      {"label": "Baloo Da 2", "value": "'Baloo Da 2', sans-serif"},
      {"label": "Baloo Paaji 2", "value": "'Baloo Paaji 2', sans-serif"},
      {"label": "Baloo Tamma 2", "value": "'Baloo Tamma 2', sans-serif"},
      {"label": "Baloo Tammudu 2", "value": "'Baloo Tammudu 2', sans-serif"},
      {"label": "Baloo Thambi 2", "value": "'Baloo Thambi 2', sans-serif"},
      {"label": "Balsamiq Sans", "value": "'Balsamiq Sans', sans-serif"},
      {"label": "Balthazar", "value": "Balthazar, serif"},
      {"label": "Bangers", "value": "Bangers, sans-serif"},
      {"label": "Barlow", "value": "Barlow, sans-serif"},
      {"label": "Barlow Condensed", "value": "'Barlow Condensed', sans-serif"},
      {"label": "Barlow Semi Condensed", "value": "'Barlow Semi Condensed', sans-serif"},
      {"label": "Barriecito", "value": "Barriecito, sans-serif"},
      {"label": "Barrio", "value": "Barrio, sans-serif"},
      {"label": "Basic", "value": "Basic, sans-serif"},
      {"label": "Baskervville", "value": "Baskervville, serif"},
      {"label": "Baskervville SC", "value": "'Baskervville SC', serif"},
      {"label": "Battambang", "value": "Battambang, sans-serif"},
      {"label": "Baumans", "value": "Baumans, sans-serif"},
      {"label": "Bayon", "value": "Bayon, sans-serif"},
      {"label": "BBH Bartle", "value": "'BBH Bartle', sans-serif"},
      {"label": "BBH Bogle", "value": "'BBH Bogle', sans-serif"},
      {"label": "BBH Hegarty", "value": "'BBH Hegarty', sans-serif"},
      {"label": "Be Vietnam Pro", "value": "'Be Vietnam Pro', sans-serif"},
      {"label": "Beau Rivage", "value": "'Beau Rivage', cursive"},
      {"label": "Bebas Neue", "value": "'Bebas Neue', sans-serif"},
      {"label": "Beiruti", "value": "Beiruti, sans-serif"},
      {"label": "Belanosima", "value": "Belanosima, sans-serif"},
      {"label": "Belgrano", "value": "Belgrano, serif"},
      {"label": "Bellefair", "value": "Bellefair, serif"},
      {"label": "Belleza", "value": "Belleza, sans-serif"},
      {"label": "Bellota", "value": "Bellota, sans-serif"},
      {"label": "Bellota Text", "value": "'Bellota Text', sans-serif"},
      {"label": "BenchNine", "value": "BenchNine, sans-serif"},
      {"label": "Benne", "value": "Benne, serif"},
      {"label": "Bentham", "value": "Bentham, serif"},
      {"label": "Berkshire Swash", "value": "'Berkshire Swash', cursive"},
      {"label": "Besley", "value": "Besley, serif"},
      {"label": "Betania Patmos", "value": "'Betania Patmos', cursive"},
      {"label": "Betania Patmos GDL", "value": "'Betania Patmos GDL', cursive"},
      {"label": "Betania Patmos In", "value": "'Betania Patmos In', cursive"},
      {"label": "Betania Patmos In GDL", "value": "'Betania Patmos In GDL', cursive"},
      {"label": "Beth Ellen", "value": "'Beth Ellen', cursive"},
      {"label": "Bevan", "value": "Bevan, serif"},
      {"label": "BhuTuka Expanded One", "value": "'BhuTuka Expanded One', serif"},
      {"label": "Big Shoulders", "value": "'Big Shoulders', sans-serif"},
      {"label": "Big Shoulders Inline", "value": "'Big Shoulders Inline', sans-serif"},
      {"label": "Big Shoulders Stencil", "value": "'Big Shoulders Stencil', sans-serif"},
      {"label": "Bigelow Rules", "value": "'Bigelow Rules', sans-serif"},
      {"label": "Bigshot One", "value": "'Bigshot One', sans-serif"},
      {"label": "Bilbo", "value": "Bilbo, cursive"},
      {"label": "Bilbo Swash Caps", "value": "'Bilbo Swash Caps', cursive"},
      {"label": "BioRhyme", "value": "BioRhyme, serif"},
      {"label": "BioRhyme Expanded", "value": "'BioRhyme Expanded', serif"},
      {"label": "Birthstone", "value": "Birthstone, cursive"},
      {"label": "Birthstone Bounce", "value": "'Birthstone Bounce', cursive"},
      {"label": "Biryani", "value": "Biryani, sans-serif"},
      {"label": "Bitcount", "value": "Bitcount, sans-serif"},
      {"label": "Bitcount Grid Double", "value": "'Bitcount Grid Double', sans-serif"},
      {"label": "Bitcount Grid Double Ink", "value": "'Bitcount Grid Double Ink', sans-serif"},
      {"label": "Bitcount Grid Single", "value": "'Bitcount Grid Single', sans-serif"},
      {"label": "Bitcount Grid Single Ink", "value": "'Bitcount Grid Single Ink', sans-serif"},
      {"label": "Bitcount Ink", "value": "'Bitcount Ink', sans-serif"},
      {"label": "Bitcount Prop Double", "value": "'Bitcount Prop Double', sans-serif"},
      {"label": "Bitcount Prop Double Ink", "value": "'Bitcount Prop Double Ink', sans-serif"},
      {"label": "Bitcount Prop Single", "value": "'Bitcount Prop Single', sans-serif"},
      {"label": "Bitcount Prop Single Ink", "value": "'Bitcount Prop Single Ink', sans-serif"},
      {"label": "Bitcount Single", "value": "'Bitcount Single', sans-serif"},
      {"label": "Bitcount Single Ink", "value": "'Bitcount Single Ink', sans-serif"},
      {"label": "Bitter", "value": "Bitter, serif"},
      {"label": "BIZ UDGothic", "value": "'BIZ UDGothic', sans-serif"},
      {"label": "BIZ UDMincho", "value": "'BIZ UDMincho', serif"},
      {"label": "BIZ UDPGothic", "value": "'BIZ UDPGothic', sans-serif"},
      {"label": "BIZ UDPMincho", "value": "'BIZ UDPMincho', serif"},
      {"label": "BJCree", "value": "BJCree, serif"},
      {"label": "Black And White Picture", "value": "'Black And White Picture', sans-serif"},
      {"label": "Black Han Sans", "value": "'Black Han Sans', sans-serif"},
      {"label": "Black Ops One", "value": "'Black Ops One', sans-serif"},
      {"label": "Blaka", "value": "Blaka, sans-serif"},
      {"label": "Blaka Hollow", "value": "'Blaka Hollow', sans-serif"},
      {"label": "Blaka Ink", "value": "'Blaka Ink', sans-serif"},
      {"label": "Blinker", "value": "Blinker, sans-serif"},
      {"label": "Bodoni Moda", "value": "'Bodoni Moda', serif"},
      {"label": "Bodoni Moda SC", "value": "'Bodoni Moda SC', serif"},
      {"label": "Bokor", "value": "Bokor, sans-serif"},
      {"label": "Boldonse", "value": "Boldonse, sans-serif"},
      {"label": "Bona Nova", "value": "'Bona Nova', serif"},
      {"label": "Bona Nova SC", "value": "'Bona Nova SC', serif"},
      {"label": "Bonbon", "value": "Bonbon, cursive"},
      {"label": "Bonheur Royale", "value": "'Bonheur Royale', cursive"},
      {"label": "Boogaloo", "value": "Boogaloo, sans-serif"},
      {"label": "Borel", "value": "Borel, cursive"},
      {"label": "Bowlby One", "value": "'Bowlby One', sans-serif"},
      {"label": "Bowlby One SC", "value": "'Bowlby One SC', sans-serif"},
      {"label": "Bpmf Huninn", "value": "'Bpmf Huninn', sans-serif"},
      {"label": "Bpmf Iansui", "value": "'Bpmf Iansui', cursive"},
      {"label": "Bpmf Zihi Kai Std", "value": "'Bpmf Zihi Kai Std', sans-serif"},
      {"label": "Braah One", "value": "'Braah One', sans-serif"},
      {"label": "Brawler", "value": "Brawler, serif"},
      {"label": "Bree Serif", "value": "'Bree Serif', serif"},
      {"label": "Bricolage Grotesque", "value": "'Bricolage Grotesque', sans-serif"},
      {"label": "Bruno Ace", "value": "'Bruno Ace', sans-serif"},
      {"label": "Bruno Ace SC", "value": "'Bruno Ace SC', sans-serif"},
      {"label": "Brygada 1918", "value": "'Brygada 1918', serif"},
      {"label": "Bubblegum Sans", "value": "'Bubblegum Sans', sans-serif"},
      {"label": "Bubbler One", "value": "'Bubbler One', sans-serif"},
      {"label": "Buda", "value": "Buda, sans-serif"},
      {"label": "Buenard", "value": "Buenard, serif"},
      {"label": "Bungee", "value": "Bungee, sans-serif"},
      {"label": "Bungee Hairline", "value": "'Bungee Hairline', sans-serif"},
      {"label": "Bungee Inline", "value": "'Bungee Inline', sans-serif"},
      {"label": "Bungee Outline", "value": "'Bungee Outline', sans-serif"},
      {"label": "Bungee Shade", "value": "'Bungee Shade', sans-serif"},
      {"label": "Bungee Spice", "value": "'Bungee Spice', sans-serif"},
      {"label": "Bungee Tint", "value": "'Bungee Tint', sans-serif"},
      {"label": "Butcherman", "value": "Butcherman, sans-serif"},
      {"label": "Butterfly Kids", "value": "'Butterfly Kids', cursive"},
      {"label": "Bytesized", "value": "Bytesized, sans-serif"},
      {"label": "Caacupe One", "value": "'Caacupe One', sans-serif"},
      {"label": "Cabin", "value": "Cabin, sans-serif"},
      {"label": "Cabin Condensed", "value": "'Cabin Condensed', sans-serif"},
      {"label": "Cabin Sketch", "value": "'Cabin Sketch', sans-serif"},
      {"label": "Cactus Classical Serif", "value": "'Cactus Classical Serif', serif"},
      {"label": "Caesar Dressing", "value": "'Caesar Dressing', sans-serif"},
      {"label": "Cagliostro", "value": "Cagliostro, sans-serif"},
      {"label": "Cairo", "value": "Cairo, sans-serif"},
      {"label": "Cairo Play", "value": "'Cairo Play', sans-serif"},
      {"label": "Cal Sans", "value": "'Cal Sans', sans-serif"},
      {"label": "Caladea", "value": "Caladea, serif"},
      {"label": "Calistoga", "value": "Calistoga, sans-serif"},
      {"label": "Calligraffitti", "value": "Calligraffitti, cursive"},
      {"label": "Cambay", "value": "Cambay, sans-serif"},
      {"label": "Cambo", "value": "Cambo, serif"},
      {"label": "Candal", "value": "Candal, sans-serif"},
      {"label": "Cantarell", "value": "Cantarell, sans-serif"},
      {"label": "Cantata One", "value": "'Cantata One', serif"},
      {"label": "Cantora One", "value": "'Cantora One', sans-serif"},
      {"label": "Caprasimo", "value": "Caprasimo, sans-serif"},
      {"label": "Capriola", "value": "Capriola, sans-serif"},
      {"label": "Caramel", "value": "Caramel, cursive"},
      {"label": "Carattere", "value": "Carattere, cursive"},
      {"label": "Cardo", "value": "Cardo, serif"},
      {"label": "Carlito", "value": "Carlito, sans-serif"},
      {"label": "Carme", "value": "Carme, sans-serif"},
      {"label": "Carrois Gothic", "value": "'Carrois Gothic', sans-serif"},
      {"label": "Carrois Gothic SC", "value": "'Carrois Gothic SC', sans-serif"},
      {"label": "Carter One", "value": "'Carter One', sans-serif"},
      {"label": "Cascadia Code", "value": "'Cascadia Code', sans-serif"},
      {"label": "Cascadia Mono", "value": "'Cascadia Mono', sans-serif"},
      {"label": "Castoro", "value": "Castoro, serif"},
      {"label": "Castoro Titling", "value": "'Castoro Titling', sans-serif"},
      {"label": "Catamaran", "value": "Catamaran, sans-serif"},
      {"label": "Caudex", "value": "Caudex, serif"},
      {"label": "Cause", "value": "Cause, cursive"},
      {"label": "Caveat", "value": "Caveat, cursive"},
      {"label": "Caveat Brush", "value": "'Caveat Brush', cursive"},
      {"label": "Cedarville Cursive", "value": "'Cedarville Cursive', cursive"},
      {"label": "Ceviche One", "value": "'Ceviche One', sans-serif"},
      {"label": "Chakra Petch", "value": "'Chakra Petch', sans-serif"},
      {"label": "Changa", "value": "Changa, sans-serif"},
      {"label": "Changa One", "value": "'Changa One', sans-serif"},
      {"label": "Chango", "value": "Chango, sans-serif"},
      {"label": "Charis SIL", "value": "'Charis SIL', serif"},
      {"label": "Charm", "value": "Charm, cursive"},
      {"label": "Charmonman", "value": "Charmonman, cursive"},
      {"label": "Chathura", "value": "Chathura, sans-serif"},
      {"label": "Chau Philomene One", "value": "'Chau Philomene One', sans-serif"},
      {"label": "Chela One", "value": "'Chela One', sans-serif"},
      {"label": "Chelsea Market", "value": "'Chelsea Market', sans-serif"},
      {"label": "Chenla", "value": "Chenla, sans-serif"},
      {"label": "Cherish", "value": "Cherish, cursive"},
      {"label": "Cherry Bomb One", "value": "'Cherry Bomb One', sans-serif"},
      {"label": "Cherry Cream Soda", "value": "'Cherry Cream Soda', sans-serif"},
      {"label": "Cherry Swash", "value": "'Cherry Swash', sans-serif"},
      {"label": "Chewy", "value": "Chewy, sans-serif"},
      {"label": "Chicle", "value": "Chicle, sans-serif"},
      {"label": "Chilanka", "value": "Chilanka, cursive"},
      {"label": "Chiron GoRound TC", "value": "'Chiron GoRound TC', sans-serif"},
      {"label": "Chiron Hei HK", "value": "'Chiron Hei HK', sans-serif"},
      {"label": "Chiron Sung HK", "value": "'Chiron Sung HK', serif"},
      {"label": "Chivo", "value": "Chivo, sans-serif"},
      {"label": "Chivo Mono", "value": "'Chivo Mono', monospace"},
      {"label": "Chocolate Classical Sans", "value": "'Chocolate Classical Sans', sans-serif"},
      {"label": "Chokokutai", "value": "Chokokutai, sans-serif"},
      {"label": "Chonburi", "value": "Chonburi, sans-serif"},
      {"label": "Cinzel", "value": "Cinzel, serif"},
      {"label": "Cinzel Decorative", "value": "'Cinzel Decorative', sans-serif"},
      {"label": "Clarity City", "value": "'Clarity City', sans-serif"},
      {"label": "Clicker Script", "value": "'Clicker Script', cursive"},
      {"label": "Climate Crisis", "value": "'Climate Crisis', sans-serif"},
      {"label": "Coda", "value": "Coda, sans-serif"},
      {"label": "Codystar", "value": "Codystar, sans-serif"},
      {"label": "Coiny", "value": "Coiny, sans-serif"},
      {"label": "Combo", "value": "Combo, sans-serif"},
      {"label": "Comfortaa", "value": "Comfortaa, cursive"},
      {"label": "Comforter", "value": "Comforter, cursive"},
      {"label": "Comforter Brush", "value": "'Comforter Brush', cursive"},
      {"label": "Comic Neue", "value": "'Comic Neue', cursive"},
      {"label": "Comic Relief", "value": "'Comic Relief', sans-serif"},
      {"label": "Comic Sans MS", "value": "'Comic Sans MS', 'Comic Sans', cursive"},
      {"label": "Coming Soon", "value": "'Coming Soon', cursive"},
      {"label": "Comme", "value": "Comme, sans-serif"},
      {"label": "Commissioner", "value": "Commissioner, sans-serif"},
      {"label": "Concert One", "value": "'Concert One', sans-serif"},
      {"label": "Condiment", "value": "Condiment, cursive"},
      {"label": "Content", "value": "Content, sans-serif"},
      {"label": "Contrail One", "value": "'Contrail One', sans-serif"},
      {"label": "Convergence", "value": "Convergence, sans-serif"},
      {"label": "Cookie", "value": "Cookie, cursive"},
      {"label": "Copse", "value": "Copse, serif"},
      {"label": "Coral Pixels", "value": "'Coral Pixels', sans-serif"},
      {"label": "Corben", "value": "Corben, sans-serif"},
      {"label": "Corinthia", "value": "Corinthia, cursive"},
      {"label": "Cormorant", "value": "Cormorant, serif"},
      {"label": "Cormorant Garamond", "value": "'Cormorant Garamond', serif"},
      {"label": "Cormorant Infant", "value": "'Cormorant Infant', serif"},
      {"label": "Cormorant SC", "value": "'Cormorant SC', serif"},
      {"label": "Cormorant Unicase", "value": "'Cormorant Unicase', serif"},
      {"label": "Cormorant Upright", "value": "'Cormorant Upright', serif"},
      {"label": "Cossette Texte", "value": "'Cossette Texte', sans-serif"},
      {"label": "Cossette Titre", "value": "'Cossette Titre', sans-serif"},
      {"label": "Courgette", "value": "Courgette, cursive"},
      {"label": "Courier New", "value": "'Courier New', Courier, monospace"},
      {"label": "Courier Prime", "value": "'Courier Prime', monospace"},
      {"label": "Cousine", "value": "Cousine, monospace"},
      {"label": "Coustard", "value": "Coustard, serif"},
      {"label": "Covered By Your Grace", "value": "'Covered By Your Grace', cursive"},
      {"label": "Crafty Girls", "value": "'Crafty Girls', cursive"},
      {"label": "Creepster", "value": "Creepster, sans-serif"},
      {"label": "Crete Round", "value": "'Crete Round', serif"},
      {"label": "Crimson Pro", "value": "'Crimson Pro', serif"},
      {"label": "Crimson Text", "value": "'Crimson Text', serif"},
      {"label": "Croissant One", "value": "'Croissant One', sans-serif"},
      {"label": "Crushed", "value": "Crushed, sans-serif"},
      {"label": "Cuprum", "value": "Cuprum, sans-serif"},
      {"label": "Cute Font", "value": "'Cute Font', sans-serif"},
      {"label": "Cutive", "value": "Cutive, serif"},
      {"label": "Cutive Mono", "value": "'Cutive Mono', monospace"},
      {"label": "Dai Banna SIL", "value": "'Dai Banna SIL', serif"},
      {"label": "Damion", "value": "Damion, cursive"},
      {"label": "Dancing Script", "value": "'Dancing Script', cursive"},
      {"label": "Danfo", "value": "Danfo, serif"},
      {"label": "Dangrek", "value": "Dangrek, sans-serif"},
      {"label": "Darker Grotesque", "value": "'Darker Grotesque', sans-serif"},
      {"label": "Darumadrop One", "value": "'Darumadrop One', sans-serif"},
      {"label": "Datatype", "value": "Datatype, monospace"},
      {"label": "David Libre", "value": "'David Libre', serif"},
      {"label": "Dawning of a New Day", "value": "'Dawning of a New Day', cursive"},
      {"label": "Days One", "value": "'Days One', sans-serif"},
      {"label": "Dekko", "value": "Dekko, cursive"},
      {"label": "Dela Gothic One", "value": "'Dela Gothic One', sans-serif"},
      {"label": "Delicious Handrawn", "value": "'Delicious Handrawn', cursive"},
      {"label": "Delius", "value": "Delius, cursive"},
      {"label": "Delius Swash Caps", "value": "'Delius Swash Caps', cursive"},
      {"label": "Delius Unicase", "value": "'Delius Unicase', cursive"},
      {"label": "Della Respira", "value": "'Della Respira', serif"},
      {"label": "Denk One", "value": "'Denk One', sans-serif"},
      {"label": "Devonshire", "value": "Devonshire, cursive"},
      {"label": "Dhurjati", "value": "Dhurjati, sans-serif"},
      {"label": "Didact Gothic", "value": "'Didact Gothic', sans-serif"},
      {"label": "Diphylleia", "value": "Diphylleia, serif"},
      {"label": "Diplomata", "value": "Diplomata, sans-serif"},
      {"label": "Diplomata SC", "value": "'Diplomata SC', sans-serif"},
      {"label": "DM Mono", "value": "'DM Mono', monospace"},
      {"label": "DM Sans", "value": "'DM Sans', sans-serif"},
      {"label": "DM Serif Display", "value": "'DM Serif Display', serif"},
      {"label": "DM Serif Text", "value": "'DM Serif Text', serif"},
      {"label": "Do Hyeon", "value": "'Do Hyeon', sans-serif"},
      {"label": "Dokdo", "value": "Dokdo, sans-serif"},
      {"label": "Domine", "value": "Domine, serif"},
      {"label": "Donegal One", "value": "'Donegal One', serif"},
      {"label": "Dongle", "value": "Dongle, sans-serif"},
      {"label": "Doppio One", "value": "'Doppio One', sans-serif"},
      {"label": "Dorsa", "value": "Dorsa, sans-serif"},
      {"label": "Dosis", "value": "Dosis, sans-serif"},
      {"label": "DotGothic16", "value": "'DotGothic16', sans-serif"},
      {"label": "Doto", "value": "Doto, sans-serif"},
      {"label": "Dr Sugiyama", "value": "'Dr Sugiyama', cursive"},
      {"label": "Duru Sans", "value": "'Duru Sans', sans-serif"},
      {"label": "Dynalight", "value": "Dynalight, sans-serif"},
      {"label": "DynaPuff", "value": "DynaPuff, sans-serif"},
      {"label": "Eagle Lake", "value": "'Eagle Lake', cursive"},
      {"label": "East Sea Dokdo", "value": "'East Sea Dokdo', cursive"},
      {"label": "Eater", "value": "Eater, sans-serif"},
      {"label": "EB Garamond", "value": "'EB Garamond', serif"},
      {"label": "Economica", "value": "Economica, sans-serif"},
      {"label": "Eczar", "value": "Eczar, serif"},
      {"label": "Edu AU VIC WA NT Arrows", "value": "'Edu AU VIC WA NT Arrows', cursive"},
      {"label": "Edu AU VIC WA NT Dots", "value": "'Edu AU VIC WA NT Dots', cursive"},
      {"label": "Edu AU VIC WA NT Guides", "value": "'Edu AU VIC WA NT Guides', cursive"},
      {"label": "Edu AU VIC WA NT Hand", "value": "'Edu AU VIC WA NT Hand', cursive"},
      {"label": "Edu AU VIC WA NT Pre", "value": "'Edu AU VIC WA NT Pre', cursive"},
      {"label": "Edu NSW ACT Cursive", "value": "'Edu NSW ACT Cursive', cursive"},
      {"label": "Edu NSW ACT Foundation", "value": "'Edu NSW ACT Foundation', cursive"},
      {"label": "Edu NSW ACT Hand Pre", "value": "'Edu NSW ACT Hand Pre', cursive"},
      {"label": "Edu QLD Beginner", "value": "'Edu QLD Beginner', cursive"},
      {"label": "Edu QLD Hand", "value": "'Edu QLD Hand', cursive"},
      {"label": "Edu SA Beginner", "value": "'Edu SA Beginner', cursive"},
      {"label": "Edu SA Hand", "value": "'Edu SA Hand', cursive"},
      {"label": "Edu TAS Beginner", "value": "'Edu TAS Beginner', cursive"},
      {"label": "Edu VIC WA NT Beginner", "value": "'Edu VIC WA NT Beginner', cursive"},
      {"label": "Edu VIC WA NT Hand", "value": "'Edu VIC WA NT Hand', cursive"},
      {"label": "Edu VIC WA NT Hand Pre", "value": "'Edu VIC WA NT Hand Pre', cursive"},
      {"label": "El Messiri", "value": "'El Messiri', sans-serif"},
      {"label": "Electrolize", "value": "Electrolize, sans-serif"},
      {"label": "Elms Sans", "value": "'Elms Sans', sans-serif"},
      {"label": "Elsie", "value": "Elsie, sans-serif"},
      {"label": "Elsie Swash Caps", "value": "'Elsie Swash Caps', sans-serif"},
      {"label": "Emblema One", "value": "'Emblema One', sans-serif"},
      {"label": "Emilys Candy", "value": "'Emilys Candy', sans-serif"},
      {"label": "Encode Sans", "value": "'Encode Sans', sans-serif"},
      {"label": "Encode Sans Condensed", "value": "'Encode Sans Condensed', sans-serif"},
      {"label": "Encode Sans Expanded", "value": "'Encode Sans Expanded', sans-serif"},
      {"label": "Encode Sans SC", "value": "'Encode Sans SC', sans-serif"},
      {"label": "Encode Sans Semi Condensed", "value": "'Encode Sans Semi Condensed', sans-serif"},
      {"label": "Encode Sans Semi Expanded", "value": "'Encode Sans Semi Expanded', sans-serif"},
      {"label": "Engagement", "value": "Engagement, cursive"},
      {"label": "Englebert", "value": "Englebert, sans-serif"},
      {"label": "Enriqueta", "value": "Enriqueta, serif"},
      {"label": "Ephesis", "value": "Ephesis, cursive"},
      {"label": "Epilogue", "value": "Epilogue, sans-serif"},
      {"label": "Epunda Sans", "value": "'Epunda Sans', sans-serif"},
      {"label": "Epunda Slab", "value": "'Epunda Slab', serif"},
      {"label": "Erica One", "value": "'Erica One', sans-serif"},
      {"label": "Esteban", "value": "Esteban, serif"},
      {"label": "Estedad", "value": "Estedad, sans-serif"},
      {"label": "Estonia", "value": "Estonia, cursive"},
      {"label": "Euphoria Script", "value": "'Euphoria Script', cursive"},
      {"label": "Ewert", "value": "Ewert, sans-serif"},
      {"label": "Exile", "value": "Exile, sans-serif"},
      {"label": "Exo", "value": "Exo, sans-serif"},
      {"label": "Exo 2", "value": "'Exo 2', sans-serif"},
      {"label": "Expletus Sans", "value": "'Expletus Sans', sans-serif"},
      {"label": "Explora", "value": "Explora, cursive"},
      {"label": "Faculty Glyphic", "value": "'Faculty Glyphic', sans-serif"},
      {"label": "Fahkwang", "value": "Fahkwang, sans-serif"},
      {"label": "Familjen Grotesk", "value": "'Familjen Grotesk', sans-serif"},
      {"label": "Fanwood Text", "value": "'Fanwood Text', serif"},
      {"label": "Farro", "value": "Farro, sans-serif"},
      {"label": "Farsan", "value": "Farsan, sans-serif"},
      {"label": "Fascinate", "value": "Fascinate, sans-serif"},
      {"label": "Fascinate Inline", "value": "'Fascinate Inline', sans-serif"},
      {"label": "Faster One", "value": "'Faster One', sans-serif"},
      {"label": "Fasthand", "value": "Fasthand, sans-serif"},
      {"label": "Fauna One", "value": "'Fauna One', serif"},
      {"label": "Faustina", "value": "Faustina, serif"},
      {"label": "Federant", "value": "Federant, sans-serif"},
      {"label": "Federo", "value": "Federo, sans-serif"},
      {"label": "Felipa", "value": "Felipa, cursive"},
      {"label": "Fenix", "value": "Fenix, serif"},
      {"label": "Festive", "value": "Festive, cursive"},
      {"label": "Figtree", "value": "Figtree, sans-serif"},
      {"label": "Finger Paint", "value": "'Finger Paint', sans-serif"},
      {"label": "Finlandica Headline", "value": "'Finlandica Headline', sans-serif"},
      {"label": "Finlandica Text", "value": "'Finlandica Text', sans-serif"},
      {"label": "Fira Code", "value": "'Fira Code', monospace"},
      {"label": "Fira Mono", "value": "'Fira Mono', monospace"},
      {"label": "Fira Sans", "value": "'Fira Sans', sans-serif"},
      {"label": "Fira Sans Condensed", "value": "'Fira Sans Condensed', sans-serif"},
      {"label": "Fira Sans Extra Condensed", "value": "'Fira Sans Extra Condensed', sans-serif"},
      {"label": "Fjalla One", "value": "'Fjalla One', sans-serif"},
      {"label": "Fjord One", "value": "'Fjord One', serif"},
      {"label": "Flamenco", "value": "Flamenco, sans-serif"},
      {"label": "Flavors", "value": "Flavors, sans-serif"},
      {"label": "Fleur De Leah", "value": "'Fleur De Leah', cursive"},
      {"label": "Flow Block", "value": "'Flow Block', sans-serif"},
      {"label": "Flow Circular", "value": "'Flow Circular', sans-serif"},
      {"label": "Flow Rounded", "value": "'Flow Rounded', sans-serif"},
      {"label": "Foldit", "value": "Foldit, sans-serif"},
      {"label": "Fondamento", "value": "Fondamento, cursive"},
      {"label": "Fontdiner Swanky", "value": "'Fontdiner Swanky', sans-serif"},
      {"label": "Forum", "value": "Forum, sans-serif"},
      {"label": "Fragment Mono", "value": "'Fragment Mono', monospace"},
      {"label": "Francois One", "value": "'Francois One', sans-serif"},
      {"label": "Frank Ruhl Libre", "value": "'Frank Ruhl Libre', serif"},
      {"label": "Fraunces", "value": "Fraunces, serif"},
      {"label": "Freckle Face", "value": "'Freckle Face', sans-serif"},
      {"label": "Fredericka the Great", "value": "'Fredericka the Great', sans-serif"},
      {"label": "Fredoka", "value": "Fredoka, sans-serif"},
      {"label": "Freehand", "value": "Freehand, sans-serif"},
      {"label": "Freeman", "value": "Freeman, sans-serif"},
      {"label": "Fresca", "value": "Fresca, sans-serif"},
      {"label": "Frijole", "value": "Frijole, sans-serif"},
      {"label": "Fruktur", "value": "Fruktur, sans-serif"},
      {"label": "Fugaz One", "value": "'Fugaz One', sans-serif"},
      {"label": "Fuggles", "value": "Fuggles, cursive"},
      {"label": "Funnel Display", "value": "'Funnel Display', sans-serif"},
      {"label": "Funnel Sans", "value": "'Funnel Sans', sans-serif"},
      {"label": "Fustat", "value": "Fustat, sans-serif"},
      {"label": "Fuzzy Bubbles", "value": "'Fuzzy Bubbles', cursive"},
      {"label": "Ga Maamli", "value": "'Ga Maamli', sans-serif"},
      {"label": "Gabarito", "value": "Gabarito, sans-serif"},
      {"label": "Gabriela", "value": "Gabriela, serif"},
      {"label": "Gaegu", "value": "Gaegu, cursive"},
      {"label": "Gafata", "value": "Gafata, sans-serif"},
      {"label": "Gajraj One", "value": "'Gajraj One', sans-serif"},
      {"label": "Galada", "value": "Galada, sans-serif"},
      {"label": "Galdeano", "value": "Galdeano, sans-serif"},
      {"label": "Galindo", "value": "Galindo, sans-serif"},
      {"label": "Gamja Flower", "value": "'Gamja Flower', cursive"},
      {"label": "Gantari", "value": "Gantari, sans-serif"},
      {"label": "Gasoek One", "value": "'Gasoek One', sans-serif"},
      {"label": "Gayathri", "value": "Gayathri, sans-serif"},
      {"label": "Geist", "value": "Geist, sans-serif"},
      {"label": "Geist Mono", "value": "'Geist Mono', monospace"},
      {"label": "Geist Pixel", "value": "'Geist Pixel', sans-serif"},
      {"label": "Gelasio", "value": "Gelasio, serif"},
      {"label": "Gemunu Libre", "value": "'Gemunu Libre', sans-serif"},
      {"label": "Genos", "value": "Genos, sans-serif"},
      {"label": "Gentium Book Plus", "value": "'Gentium Book Plus', serif"},
      {"label": "Gentium Plus", "value": "'Gentium Plus', serif"},
      {"label": "Geo", "value": "Geo, sans-serif"},
      {"label": "Geologica", "value": "Geologica, sans-serif"},
      {"label": "Geom", "value": "Geom, sans-serif"},
      {"label": "Geomini", "value": "Geomini, sans-serif"},
      {"label": "Georama", "value": "Georama, sans-serif"},
      {"label": "Georgia", "value": "Georgia, 'Times New Roman', serif"},
      {"label": "Geostar", "value": "Geostar, sans-serif"},
      {"label": "Geostar Fill", "value": "'Geostar Fill', sans-serif"},
      {"label": "Germania One", "value": "'Germania One', sans-serif"},
      {"label": "GFS Didot", "value": "'GFS Didot', serif"},
      {"label": "GFS Neohellenic", "value": "'GFS Neohellenic', sans-serif"},
      {"label": "Gideon Roman", "value": "'Gideon Roman', sans-serif"},
      {"label": "Gidole", "value": "Gidole, sans-serif"},
      {"label": "Gidugu", "value": "Gidugu, sans-serif"},
      {"label": "Gilda Display", "value": "'Gilda Display', serif"},
      {"label": "Girassol", "value": "Girassol, sans-serif"},
      {"label": "Give You Glory", "value": "'Give You Glory', cursive"},
      {"label": "Glass Antiqua", "value": "'Glass Antiqua', sans-serif"},
      {"label": "Glegoo", "value": "Glegoo, serif"},
      {"label": "Gloock", "value": "Gloock, serif"},
      {"label": "Gloria Hallelujah", "value": "'Gloria Hallelujah', cursive"},
      {"label": "Glory", "value": "Glory, sans-serif"},
      {"label": "Gluten", "value": "Gluten, sans-serif"},
      {"label": "Goblin One", "value": "'Goblin One', sans-serif"},
      {"label": "Gochi Hand", "value": "'Gochi Hand', cursive"},
      {"label": "Goldman", "value": "Goldman, sans-serif"},
      {"label": "Golos Text", "value": "'Golos Text', sans-serif"},
      {"label": "Google Sans", "value": "'Google Sans', sans-serif"},
      {"label": "Google Sans Code", "value": "'Google Sans Code', monospace"},
      {"label": "Google Sans Flex", "value": "'Google Sans Flex', sans-serif"},
      {"label": "Gorditas", "value": "Gorditas, sans-serif"},
      {"label": "Gothic A1", "value": "'Gothic A1', sans-serif"},
      {"label": "Gotu", "value": "Gotu, sans-serif"},
      {"label": "Goudy Bookletter 1911", "value": "'Goudy Bookletter 1911', serif"},
      {"label": "Gowun Batang", "value": "'Gowun Batang', serif"},
      {"label": "Gowun Dodum", "value": "'Gowun Dodum', sans-serif"},
      {"label": "Graduate", "value": "Graduate, serif"},
      {"label": "Grand Hotel", "value": "'Grand Hotel', cursive"},
      {"label": "Grandiflora One", "value": "'Grandiflora One', serif"},
      {"label": "Grandstander", "value": "Grandstander, sans-serif"},
      {"label": "Grape Nuts", "value": "'Grape Nuts', cursive"},
      {"label": "Gravitas One", "value": "'Gravitas One', sans-serif"},
      {"label": "Great Vibes", "value": "'Great Vibes', cursive"},
      {"label": "Grechen Fuemen", "value": "'Grechen Fuemen', cursive"},
      {"label": "Grenze", "value": "Grenze, serif"},
      {"label": "Grenze Gotisch", "value": "'Grenze Gotisch', sans-serif"},
      {"label": "Grey Qo", "value": "'Grey Qo', cursive"},
      {"label": "Griffy", "value": "Griffy, sans-serif"},
      {"label": "Gruppo", "value": "Gruppo, sans-serif"},
      {"label": "Gudea", "value": "Gudea, sans-serif"},
      {"label": "Gugi", "value": "Gugi, sans-serif"},
      {"label": "Gulzar", "value": "Gulzar, serif"},
      {"label": "Gupter", "value": "Gupter, serif"},
      {"label": "Gurajada", "value": "Gurajada, sans-serif"},
      {"label": "Gveret Levin", "value": "'Gveret Levin', cursive"},
      {"label": "Gwendolyn", "value": "Gwendolyn, cursive"},
      {"label": "Habibi", "value": "Habibi, serif"},
      {"label": "Hachi Maru Pop", "value": "'Hachi Maru Pop', cursive"},
      {"label": "Hahmlet", "value": "Hahmlet, serif"},
      {"label": "Halant", "value": "Halant, serif"},
      {"label": "Hammersmith One", "value": "'Hammersmith One', sans-serif"},
      {"label": "Hanalei", "value": "Hanalei, sans-serif"},
      {"label": "Hanalei Fill", "value": "'Hanalei Fill', sans-serif"},
      {"label": "Handjet", "value": "Handjet, sans-serif"},
      {"label": "Handlee", "value": "Handlee, cursive"},
      {"label": "Hanken Grotesk", "value": "'Hanken Grotesk', sans-serif"},
      {"label": "Hanuman", "value": "Hanuman, serif"},
      {"label": "Happy Monkey", "value": "'Happy Monkey', sans-serif"},
      {"label": "Harmattan", "value": "Harmattan, sans-serif"},
      {"label": "Headland One", "value": "'Headland One', serif"},
      {"label": "Hedvig Letters Sans", "value": "'Hedvig Letters Sans', sans-serif"},
      {"label": "Hedvig Letters Serif", "value": "'Hedvig Letters Serif', serif"},
      {"label": "Heebo", "value": "Heebo, sans-serif"},
      {"label": "Henny Penny", "value": "'Henny Penny', sans-serif"},
      {"label": "Hepta Slab", "value": "'Hepta Slab', serif"},
      {"label": "Herr Von Muellerhoff", "value": "'Herr Von Muellerhoff', cursive"},
      {"label": "Hi Melody", "value": "'Hi Melody', cursive"},
      {"label": "Hibur Mono", "value": "'Hibur Mono', monospace"},
      {"label": "Hina Mincho", "value": "'Hina Mincho', serif"},
      {"label": "Hind", "value": "Hind, sans-serif"},
      {"label": "Hind Guntur", "value": "'Hind Guntur', sans-serif"},
      {"label": "Hind Madurai", "value": "'Hind Madurai', sans-serif"},
      {"label": "Hind Mysuru", "value": "'Hind Mysuru', sans-serif"},
      {"label": "Hind Siliguri", "value": "'Hind Siliguri', sans-serif"},
      {"label": "Hind Vadodara", "value": "'Hind Vadodara', sans-serif"},
      {"label": "Holtwood One SC", "value": "'Holtwood One SC', serif"},
      {"label": "Homemade Apple", "value": "'Homemade Apple', cursive"},
      {"label": "Homenaje", "value": "Homenaje, sans-serif"},
      {"label": "Honk", "value": "Honk, sans-serif"},
      {"label": "Host Grotesk", "value": "'Host Grotesk', sans-serif"},
      {"label": "Hubballi", "value": "Hubballi, sans-serif"},
      {"label": "Hubot Sans", "value": "'Hubot Sans', sans-serif"},
      {"label": "Huninn", "value": "Huninn, sans-serif"},
      {"label": "Hurricane", "value": "Hurricane, cursive"},
      {"label": "Iansui", "value": "Iansui, cursive"},
      {"label": "Ibarra Real Nova", "value": "'Ibarra Real Nova', serif"},
      {"label": "IBM Plex Mono", "value": "'IBM Plex Mono', monospace"},
      {"label": "IBM Plex Sans", "value": "'IBM Plex Sans', sans-serif"},
      {"label": "IBM Plex Sans Arabic", "value": "'IBM Plex Sans Arabic', sans-serif"},
      {"label": "IBM Plex Sans Condensed", "value": "'IBM Plex Sans Condensed', sans-serif"},
      {"label": "IBM Plex Sans Devanagari", "value": "'IBM Plex Sans Devanagari', sans-serif"},
      {"label": "IBM Plex Sans Hebrew", "value": "'IBM Plex Sans Hebrew', sans-serif"},
      {"label": "IBM Plex Sans JP", "value": "'IBM Plex Sans JP', sans-serif"},
      {"label": "IBM Plex Sans KR", "value": "'IBM Plex Sans KR', sans-serif"},
      {"label": "IBM Plex Sans Thai", "value": "'IBM Plex Sans Thai', sans-serif"},
      {"label": "IBM Plex Sans Thai Looped", "value": "'IBM Plex Sans Thai Looped', sans-serif"},
      {"label": "IBM Plex Serif", "value": "'IBM Plex Serif', serif"},
      {"label": "Iceberg", "value": "Iceberg, sans-serif"},
      {"label": "Iceland", "value": "Iceland, sans-serif"},
      {"label": "Idiqlat", "value": "Idiqlat, serif"},
      {"label": "IM Fell Double Pica", "value": "'IM Fell Double Pica', serif"},
      {"label": "IM Fell Double Pica SC", "value": "'IM Fell Double Pica SC', serif"},
      {"label": "IM Fell DW Pica", "value": "'IM Fell DW Pica', serif"},
      {"label": "IM Fell DW Pica SC", "value": "'IM Fell DW Pica SC', serif"},
      {"label": "IM Fell English", "value": "'IM Fell English', serif"},
      {"label": "IM Fell English SC", "value": "'IM Fell English SC', serif"},
      {"label": "IM Fell French Canon", "value": "'IM Fell French Canon', serif"},
      {"label": "IM Fell French Canon SC", "value": "'IM Fell French Canon SC', serif"},
      {"label": "IM Fell Great Primer", "value": "'IM Fell Great Primer', serif"},
      {"label": "IM Fell Great Primer SC", "value": "'IM Fell Great Primer SC', serif"},
      {"label": "Imbue", "value": "Imbue, serif"},
      {"label": "Impact", "value": "Impact, Haettenschweiler, sans-serif"},
      {"label": "Imperial Script", "value": "'Imperial Script', cursive"},
      {"label": "Imprima", "value": "Imprima, sans-serif"},
      {"label": "Inclusive Sans", "value": "'Inclusive Sans', sans-serif"},
      {"label": "Inconsolata", "value": "Inconsolata, monospace"},
      {"label": "Inder", "value": "Inder, sans-serif"},
      {"label": "Indie Flower", "value": "'Indie Flower', cursive"},
      {"label": "Ingrid Darling", "value": "'Ingrid Darling', cursive"},
      {"label": "Inika", "value": "Inika, serif"},
      {"label": "Inknut Antiqua", "value": "'Inknut Antiqua', serif"},
      {"label": "Inria Sans", "value": "'Inria Sans', sans-serif"},
      {"label": "Inria Serif", "value": "'Inria Serif', serif"},
      {"label": "Inspiration", "value": "Inspiration, cursive"},
      {"label": "Instrument Sans", "value": "'Instrument Sans', sans-serif"},
      {"label": "Instrument Serif", "value": "'Instrument Serif', serif"},
      {"label": "Intel One Mono", "value": "'Intel One Mono', monospace"},
      {"label": "Inter", "value": "Inter, Roboto, sans-serif"},
      {"label": "Inter Tight", "value": "'Inter Tight', sans-serif"},
      {"label": "Iosevka Charon", "value": "'Iosevka Charon', monospace"},
      {"label": "Iosevka Charon Mono", "value": "'Iosevka Charon Mono', monospace"},
      {"label": "Irish Grover", "value": "'Irish Grover', sans-serif"},
      {"label": "Island Moments", "value": "'Island Moments', cursive"},
      {"label": "Isometra", "value": "Isometra, serif"},
      {"label": "Istok Web", "value": "'Istok Web', sans-serif"},
      {"label": "Italiana", "value": "Italiana, sans-serif"},
      {"label": "Italianno", "value": "Italianno, cursive"},
      {"label": "Itim", "value": "Itim, cursive"},
      {"label": "Jacquard 12", "value": "'Jacquard 12', sans-serif"},
      {"label": "Jacquard 12 Charted", "value": "'Jacquard 12 Charted', sans-serif"},
      {"label": "Jacquard 24", "value": "'Jacquard 24', sans-serif"},
      {"label": "Jacquard 24 Charted", "value": "'Jacquard 24 Charted', sans-serif"},
      {"label": "Jacquarda Bastarda 9", "value": "'Jacquarda Bastarda 9', sans-serif"},
      {"label": "Jacquarda Bastarda 9 Charted", "value": "'Jacquarda Bastarda 9 Charted', sans-serif"},
      {"label": "Jacques Francois", "value": "'Jacques Francois', serif"},
      {"label": "Jacques Francois Shadow", "value": "'Jacques Francois Shadow', sans-serif"},
      {"label": "Jaini", "value": "Jaini, sans-serif"},
      {"label": "Jaini Purva", "value": "'Jaini Purva', sans-serif"},
      {"label": "Jaldi", "value": "Jaldi, sans-serif"},
      {"label": "Jaro", "value": "Jaro, sans-serif"},
      {"label": "Jersey 10", "value": "'Jersey 10', sans-serif"},
      {"label": "Jersey 10 Charted", "value": "'Jersey 10 Charted', sans-serif"},
      {"label": "Jersey 15", "value": "'Jersey 15', sans-serif"},
      {"label": "Jersey 15 Charted", "value": "'Jersey 15 Charted', sans-serif"},
      {"label": "Jersey 20", "value": "'Jersey 20', sans-serif"},
      {"label": "Jersey 20 Charted", "value": "'Jersey 20 Charted', sans-serif"},
      {"label": "Jersey 25", "value": "'Jersey 25', sans-serif"},
      {"label": "Jersey 25 Charted", "value": "'Jersey 25 Charted', sans-serif"},
      {"label": "JetBrains Mono", "value": "'JetBrains Mono', monospace"},
      {"label": "Jim Nightshade", "value": "'Jim Nightshade', cursive"},
      {"label": "Joan", "value": "Joan, serif"},
      {"label": "Jockey One", "value": "'Jockey One', sans-serif"},
      {"label": "Jolly Lodger", "value": "'Jolly Lodger', sans-serif"},
      {"label": "Jomhuria", "value": "Jomhuria, sans-serif"},
      {"label": "Jomolhari", "value": "Jomolhari, serif"},
      {"label": "Josefin Sans", "value": "'Josefin Sans', sans-serif"},
      {"label": "Josefin Slab", "value": "'Josefin Slab', serif"},
      {"label": "Jost", "value": "Jost, sans-serif"},
      {"label": "Joti One", "value": "'Joti One', sans-serif"},
      {"label": "Jua", "value": "Jua, sans-serif"},
      {"label": "Judson", "value": "Judson, serif"},
      {"label": "Julee", "value": "Julee, cursive"},
      {"label": "Julius Sans One", "value": "'Julius Sans One', sans-serif"},
      {"label": "Junge", "value": "Junge, serif"},
      {"label": "Jura", "value": "Jura, sans-serif"},
      {"label": "Just Another Hand", "value": "'Just Another Hand', cursive"},
      {"label": "Just Me Again Down Here", "value": "'Just Me Again Down Here', cursive"},
      {"label": "K2D", "value": "'K2D', sans-serif"},
      {"label": "Kablammo", "value": "Kablammo, sans-serif"},
      {"label": "Kadwa", "value": "Kadwa, serif"},
      {"label": "Kaisei Decol", "value": "'Kaisei Decol', serif"},
      {"label": "Kaisei HarunoUmi", "value": "'Kaisei HarunoUmi', serif"},
      {"label": "Kaisei Opti", "value": "'Kaisei Opti', serif"},
      {"label": "Kaisei Tokumin", "value": "'Kaisei Tokumin', serif"},
      {"label": "Kalam", "value": "Kalam, cursive"},
      {"label": "Kalnia", "value": "Kalnia, serif"},
      {"label": "Kalnia Glaze", "value": "'Kalnia Glaze', sans-serif"},
      {"label": "Kameron", "value": "Kameron, serif"},
      {"label": "Kanchenjunga", "value": "Kanchenjunga, sans-serif"},
      {"label": "Kanit", "value": "Kanit, sans-serif"},
      {"label": "Kantumruy Pro", "value": "'Kantumruy Pro', sans-serif"},
      {"label": "Kapakana", "value": "Kapakana, cursive"},
      {"label": "Karantina", "value": "Karantina, sans-serif"},
      {"label": "Karla", "value": "Karla, sans-serif"},
      {"label": "Karla Tamil Inclined", "value": "'Karla Tamil Inclined', sans-serif"},
      {"label": "Karla Tamil Upright", "value": "'Karla Tamil Upright', sans-serif"},
      {"label": "Karma", "value": "Karma, serif"},
      {"label": "Katibeh", "value": "Katibeh, sans-serif"},
      {"label": "Kaushan Script", "value": "'Kaushan Script', cursive"},
      {"label": "Kavivanar", "value": "Kavivanar, cursive"},
      {"label": "Kavoon", "value": "Kavoon, sans-serif"},
      {"label": "Kay Pho Du", "value": "'Kay Pho Du', serif"},
      {"label": "Kdam Thmor Pro", "value": "'Kdam Thmor Pro', sans-serif"},
      {"label": "Keania One", "value": "'Keania One', sans-serif"},
      {"label": "Kedebideri", "value": "Kedebideri, sans-serif"},
      {"label": "Kelly Slab", "value": "'Kelly Slab', sans-serif"},
      {"label": "Kenia", "value": "Kenia, sans-serif"},
      {"label": "Khand", "value": "Khand, sans-serif"},
      {"label": "Khmer", "value": "Khmer, sans-serif"},
      {"label": "Khula", "value": "Khula, sans-serif"},
      {"label": "Kings", "value": "Kings, cursive"},
      {"label": "Kirang Haerang", "value": "'Kirang Haerang', sans-serif"},
      {"label": "Kite One", "value": "'Kite One', sans-serif"},
      {"label": "Kiwi Maru", "value": "'Kiwi Maru', serif"},
      {"label": "Klee One", "value": "'Klee One', cursive"},
      {"label": "Knewave", "value": "Knewave, sans-serif"},
      {"label": "Kodchasan", "value": "Kodchasan, sans-serif"},
      {"label": "Kode Mono", "value": "'Kode Mono', monospace"},
      {"label": "Koh Santepheap", "value": "'Koh Santepheap', serif"},
      {"label": "KoHo", "value": "KoHo, sans-serif"},
      {"label": "Kolker Brush", "value": "'Kolker Brush', cursive"},
      {"label": "Konkhmer Sleokchher", "value": "'Konkhmer Sleokchher', sans-serif"},
      {"label": "Kosugi", "value": "Kosugi, sans-serif"},
      {"label": "Kosugi Maru", "value": "'Kosugi Maru', sans-serif"},
      {"label": "Kotta One", "value": "'Kotta One', serif"},
      {"label": "Koulen", "value": "Koulen, sans-serif"},
      {"label": "Kranky", "value": "Kranky, sans-serif"},
      {"label": "Kreon", "value": "Kreon, serif"},
      {"label": "Kripa", "value": "Kripa, sans-serif"},
      {"label": "Kristi", "value": "Kristi, cursive"},
      {"label": "Krona One", "value": "'Krona One', sans-serif"},
      {"label": "Krub", "value": "Krub, sans-serif"},
      {"label": "Kufam", "value": "Kufam, sans-serif"},
      {"label": "Kulim Park", "value": "'Kulim Park', sans-serif"},
      {"label": "Kumar One", "value": "'Kumar One', sans-serif"},
      {"label": "Kumar One Outline", "value": "'Kumar One Outline', sans-serif"},
      {"label": "Kumbh Sans", "value": "'Kumbh Sans', sans-serif"},
      {"label": "Kurale", "value": "Kurale, serif"},
      {"label": "La Belle Aurore", "value": "'La Belle Aurore', cursive"},
      {"label": "Labrada", "value": "Labrada, serif"},
      {"label": "Lacquer", "value": "Lacquer, sans-serif"},
      {"label": "Laila", "value": "Laila, serif"},
      {"label": "Lakki Reddy", "value": "'Lakki Reddy', cursive"},
      {"label": "Lalezar", "value": "Lalezar, sans-serif"},
      {"label": "Lancelot", "value": "Lancelot, sans-serif"},
      {"label": "Langar", "value": "Langar, sans-serif"},
      {"label": "Lateef", "value": "Lateef, serif"},
      {"label": "Lato", "value": "Lato, sans-serif"},
      {"label": "Lavishly Yours", "value": "'Lavishly Yours', cursive"},
      {"label": "League Gothic", "value": "'League Gothic', sans-serif"},
      {"label": "League Script", "value": "'League Script', cursive"},
      {"label": "League Spartan", "value": "'League Spartan', sans-serif"},
      {"label": "Leckerli One", "value": "'Leckerli One', cursive"},
      {"label": "Ledger", "value": "Ledger, serif"},
      {"label": "Lekton", "value": "Lekton, monospace"},
      {"label": "Lemon", "value": "Lemon, sans-serif"},
      {"label": "Lemonada", "value": "Lemonada, sans-serif"},
      {"label": "Lexend", "value": "Lexend, sans-serif"},
      {"label": "Lexend Deca", "value": "'Lexend Deca', sans-serif"},
      {"label": "Lexend Exa", "value": "'Lexend Exa', sans-serif"},
      {"label": "Lexend Giga", "value": "'Lexend Giga', sans-serif"},
      {"label": "Lexend Mega", "value": "'Lexend Mega', sans-serif"},
      {"label": "Lexend Peta", "value": "'Lexend Peta', sans-serif"},
      {"label": "Lexend Tera", "value": "'Lexend Tera', sans-serif"},
      {"label": "Lexend Zetta", "value": "'Lexend Zetta', sans-serif"},
      {"label": "Libertinus Keyboard", "value": "'Libertinus Keyboard', sans-serif"},
      {"label": "Libertinus Math", "value": "'Libertinus Math', sans-serif"},
      {"label": "Libertinus Mono", "value": "'Libertinus Mono', monospace"},
      {"label": "Libertinus Sans", "value": "'Libertinus Sans', sans-serif"},
      {"label": "Libertinus Serif", "value": "'Libertinus Serif', serif"},
      {"label": "Libertinus Serif Display", "value": "'Libertinus Serif Display', sans-serif"},
      {"label": "Libre Barcode 128", "value": "'Libre Barcode 128', sans-serif"},
      {"label": "Libre Barcode 128 Text", "value": "'Libre Barcode 128 Text', sans-serif"},
      {"label": "Libre Barcode 39", "value": "'Libre Barcode 39', sans-serif"},
      {"label": "Libre Barcode 39 Extended", "value": "'Libre Barcode 39 Extended', sans-serif"},
      {"label": "Libre Barcode 39 Extended Text", "value": "'Libre Barcode 39 Extended Text', sans-serif"},
      {"label": "Libre Barcode 39 Text", "value": "'Libre Barcode 39 Text', sans-serif"},
      {"label": "Libre Barcode EAN13 Text", "value": "'Libre Barcode EAN13 Text', sans-serif"},
      {"label": "Libre Baskerville", "value": "'Libre Baskerville', serif"},
      {"label": "Libre Bodoni", "value": "'Libre Bodoni', serif"},
      {"label": "Libre Caslon Condensed", "value": "'Libre Caslon Condensed', serif"},
      {"label": "Libre Caslon Display", "value": "'Libre Caslon Display', serif"},
      {"label": "Libre Caslon Text", "value": "'Libre Caslon Text', serif"},
      {"label": "Libre Franklin", "value": "'Libre Franklin', sans-serif"},
      {"label": "Licorice", "value": "Licorice, cursive"},
      {"label": "Life Savers", "value": "'Life Savers', sans-serif"},
      {"label": "Lilex", "value": "Lilex, monospace"},
      {"label": "Lilita One", "value": "'Lilita One', sans-serif"},
      {"label": "Lily Script One", "value": "'Lily Script One', sans-serif"},
      {"label": "Limelight", "value": "Limelight, sans-serif"},
      {"label": "Linden Hill", "value": "'Linden Hill', serif"},
      {"label": "LINE Seed JP", "value": "'LINE Seed JP', sans-serif"},
      {"label": "Linefont", "value": "Linefont, sans-serif"},
      {"label": "Lisu Bosa", "value": "'Lisu Bosa', serif"},
      {"label": "Liter", "value": "Liter, sans-serif"},
      {"label": "Literata", "value": "Literata, serif"},
      {"label": "Liu Jian Mao Cao", "value": "'Liu Jian Mao Cao', cursive"},
      {"label": "Livvic", "value": "Livvic, sans-serif"},
      {"label": "Lobster", "value": "Lobster, cursive"},
      {"label": "Lobster Two", "value": "'Lobster Two', sans-serif"},
      {"label": "Londrina Outline", "value": "'Londrina Outline', sans-serif"},
      {"label": "Londrina Shadow", "value": "'Londrina Shadow', sans-serif"},
      {"label": "Londrina Sketch", "value": "'Londrina Sketch', sans-serif"},
      {"label": "Londrina Solid", "value": "'Londrina Solid', sans-serif"},
      {"label": "Long Cang", "value": "'Long Cang', cursive"},
      {"label": "Lora", "value": "Lora, serif"},
      {"label": "Love Light", "value": "'Love Light', cursive"},
      {"label": "Love Ya Like A Sister", "value": "'Love Ya Like A Sister', sans-serif"},
      {"label": "Loved by the King", "value": "'Loved by the King', cursive"},
      {"label": "Lovers Quarrel", "value": "'Lovers Quarrel', cursive"},
      {"label": "Luckiest Guy", "value": "'Luckiest Guy', sans-serif"},
      {"label": "Lugrasimo", "value": "Lugrasimo, cursive"},
      {"label": "Lumanosimo", "value": "Lumanosimo, cursive"},
      {"label": "Lunasima", "value": "Lunasima, sans-serif"},
      {"label": "Lusitana", "value": "Lusitana, serif"},
      {"label": "Lustria", "value": "Lustria, serif"},
      {"label": "Luxurious Roman", "value": "'Luxurious Roman', sans-serif"},
      {"label": "Luxurious Script", "value": "'Luxurious Script', cursive"},
      {"label": "LXGW Marker Gothic", "value": "'LXGW Marker Gothic', sans-serif"},
      {"label": "LXGW WenKai Mono TC", "value": "'LXGW WenKai Mono TC', monospace"},
      {"label": "LXGW WenKai TC", "value": "'LXGW WenKai TC', cursive"},
      {"label": "M PLUS 1", "value": "'M PLUS 1', sans-serif"},
      {"label": "M PLUS 1 Code", "value": "'M PLUS 1 Code', monospace"},
      {"label": "M PLUS 1p", "value": "'M PLUS 1p', sans-serif"},
      {"label": "M PLUS 2", "value": "'M PLUS 2', sans-serif"},
      {"label": "M PLUS Code Latin", "value": "'M PLUS Code Latin', sans-serif"},
      {"label": "M PLUS Rounded 1c", "value": "'M PLUS Rounded 1c', sans-serif"},
      {"label": "M PLUS U", "value": "'M PLUS U', sans-serif"},
      {"label": "Ma Shan Zheng", "value": "'Ma Shan Zheng', cursive"},
      {"label": "Macondo", "value": "Macondo, sans-serif"},
      {"label": "Macondo Swash Caps", "value": "'Macondo Swash Caps', sans-serif"},
      {"label": "Mada", "value": "Mada, sans-serif"},
      {"label": "Madimi One", "value": "'Madimi One', sans-serif"},
      {"label": "Magra", "value": "Magra, sans-serif"},
      {"label": "Maiden Orange", "value": "'Maiden Orange', serif"},
      {"label": "Maitree", "value": "Maitree, serif"},
      {"label": "Major Mono Display", "value": "'Major Mono Display', monospace"},
      {"label": "Mako", "value": "Mako, sans-serif"},
      {"label": "Mali", "value": "Mali, cursive"},
      {"label": "Mallanna", "value": "Mallanna, sans-serif"},
      {"label": "Maname", "value": "Maname, serif"},
      {"label": "Mandali", "value": "Mandali, sans-serif"},
      {"label": "Manjari", "value": "Manjari, sans-serif"},
      {"label": "Manrope", "value": "Manrope, sans-serif"},
      {"label": "Mansalva", "value": "Mansalva, cursive"},
      {"label": "Manuale", "value": "Manuale, serif"},
      {"label": "Manufacturing Consent", "value": "'Manufacturing Consent', sans-serif"},
      {"label": "Marcellus", "value": "Marcellus, serif"},
      {"label": "Marcellus SC", "value": "'Marcellus SC', serif"},
      {"label": "Marck Script", "value": "'Marck Script', cursive"},
      {"label": "Margarine", "value": "Margarine, sans-serif"},
      {"label": "Marhey", "value": "Marhey, sans-serif"},
      {"label": "Markazi Text", "value": "'Markazi Text', serif"},
      {"label": "Marko One", "value": "'Marko One', serif"},
      {"label": "Marmelad", "value": "Marmelad, sans-serif"},
      {"label": "Martel", "value": "Martel, serif"},
      {"label": "Martel Sans", "value": "'Martel Sans', sans-serif"},
      {"label": "Martian Mono", "value": "'Martian Mono', monospace"},
      {"label": "Marvel", "value": "Marvel, sans-serif"},
      {"label": "Matangi", "value": "Matangi, sans-serif"},
      {"label": "Mate", "value": "Mate, serif"},
      {"label": "Mate SC", "value": "'Mate SC', serif"},
      {"label": "Matemasie", "value": "Matemasie, sans-serif"},
      {"label": "Maven Pro", "value": "'Maven Pro', sans-serif"},
      {"label": "McLaren", "value": "McLaren, sans-serif"},
      {"label": "Mea Culpa", "value": "'Mea Culpa', cursive"},
      {"label": "Meddon", "value": "Meddon, cursive"},
      {"label": "MedievalSharp", "value": "MedievalSharp, sans-serif"},
      {"label": "Medula One", "value": "'Medula One', sans-serif"},
      {"label": "Meera Inimai", "value": "'Meera Inimai', sans-serif"},
      {"label": "Megrim", "value": "Megrim, sans-serif"},
      {"label": "Meie Script", "value": "'Meie Script', cursive"},
      {"label": "Menbere", "value": "Menbere, sans-serif"},
      {"label": "Meow Script", "value": "'Meow Script', cursive"},
      {"label": "Merienda", "value": "Merienda, cursive"},
      {"label": "Merriweather", "value": "Merriweather, serif"},
      {"label": "Merriweather Sans", "value": "'Merriweather Sans', sans-serif"},
      {"label": "Metal", "value": "Metal, sans-serif"},
      {"label": "Metal Mania", "value": "'Metal Mania', sans-serif"},
      {"label": "Metamorphous", "value": "Metamorphous, sans-serif"},
      {"label": "Metrophobic", "value": "Metrophobic, sans-serif"},
      {"label": "Michroma", "value": "Michroma, sans-serif"},
      {"label": "Micro 5", "value": "'Micro 5', sans-serif"},
      {"label": "Micro 5 Charted", "value": "'Micro 5 Charted', sans-serif"},
      {"label": "Milonga", "value": "Milonga, sans-serif"},
      {"label": "Miltonian", "value": "Miltonian, sans-serif"},
      {"label": "Miltonian Tattoo", "value": "'Miltonian Tattoo', sans-serif"},
      {"label": "Mina", "value": "Mina, sans-serif"},
      {"label": "Mingzat", "value": "Mingzat, sans-serif"},
      {"label": "Miniver", "value": "Miniver, sans-serif"},
      {"label": "Miranda Sans", "value": "'Miranda Sans', sans-serif"},
      {"label": "Miriam Libre", "value": "'Miriam Libre', sans-serif"},
      {"label": "Mirza", "value": "Mirza, serif"},
      {"label": "Miss Fajardose", "value": "'Miss Fajardose', cursive"},
      {"label": "Mitr", "value": "Mitr, sans-serif"},
      {"label": "Mochiy Pop One", "value": "'Mochiy Pop One', sans-serif"},
      {"label": "Mochiy Pop P One", "value": "'Mochiy Pop P One', sans-serif"},
      {"label": "Modak", "value": "Modak, sans-serif"},
      {"label": "Modern Antiqua", "value": "'Modern Antiqua', sans-serif"},
      {"label": "Moderustic", "value": "Moderustic, sans-serif"},
      {"label": "Mogra", "value": "Mogra, sans-serif"},
      {"label": "Mohave", "value": "Mohave, sans-serif"},
      {"label": "Moirai One", "value": "'Moirai One', sans-serif"},
      {"label": "Molengo", "value": "Molengo, sans-serif"},
      {"label": "Molle", "value": "Molle, cursive"},
      {"label": "Momo Signature", "value": "'Momo Signature', sans-serif"},
      {"label": "Momo Trust Display", "value": "'Momo Trust Display', sans-serif"},
      {"label": "Momo Trust Sans", "value": "'Momo Trust Sans', sans-serif"},
      {"label": "Mona Sans", "value": "'Mona Sans', sans-serif"},
      {"label": "Monda", "value": "Monda, sans-serif"},
      {"label": "Monofett", "value": "Monofett, monospace"},
      {"label": "Monomakh", "value": "Monomakh, sans-serif"},
      {"label": "Monomaniac One", "value": "'Monomaniac One', sans-serif"},
      {"label": "Monoton", "value": "Monoton, sans-serif"},
      {"label": "Monsieur La Doulaise", "value": "'Monsieur La Doulaise', cursive"},
      {"label": "Montaga", "value": "Montaga, serif"},
      {"label": "Montagu Slab", "value": "'Montagu Slab', serif"},
      {"label": "MonteCarlo", "value": "MonteCarlo, cursive"},
      {"label": "Montenegrin Gothic One", "value": "'Montenegrin Gothic One', serif"},
      {"label": "Montez", "value": "Montez, cursive"},
      {"label": "Montserrat", "value": "Montserrat, sans-serif"},
      {"label": "Montserrat Alternates", "value": "'Montserrat Alternates', sans-serif"},
      {"label": "Montserrat Underline", "value": "'Montserrat Underline', sans-serif"},
      {"label": "Moo Lah Lah", "value": "'Moo Lah Lah', sans-serif"},
      {"label": "Mooli", "value": "Mooli, sans-serif"},
      {"label": "Moon Dance", "value": "'Moon Dance', cursive"},
      {"label": "Moul", "value": "Moul, sans-serif"},
      {"label": "Moulpali", "value": "Moulpali, sans-serif"},
      {"label": "Mountains of Christmas", "value": "'Mountains of Christmas', sans-serif"},
      {"label": "Mouse Memoirs", "value": "'Mouse Memoirs', sans-serif"},
      {"label": "Mozilla Headline", "value": "'Mozilla Headline', sans-serif"},
      {"label": "Mozilla Text", "value": "'Mozilla Text', sans-serif"},
      {"label": "Mr Bedfort", "value": "'Mr Bedfort', cursive"},
      {"label": "Mr Dafoe", "value": "'Mr Dafoe', cursive"},
      {"label": "Mr De Haviland", "value": "'Mr De Haviland', cursive"},
      {"label": "Mrs Saint Delafield", "value": "'Mrs Saint Delafield', cursive"},
      {"label": "Mrs Sheppards", "value": "'Mrs Sheppards', cursive"},
      {"label": "Ms Madi", "value": "'Ms Madi', cursive"},
      {"label": "Mukta", "value": "Mukta, sans-serif"},
      {"label": "Mukta Mahee", "value": "'Mukta Mahee', sans-serif"},
      {"label": "Mukta Malar", "value": "'Mukta Malar', sans-serif"},
      {"label": "Mukta Vaani", "value": "'Mukta Vaani', sans-serif"},
      {"label": "Mulish", "value": "Mulish, sans-serif"},
      {"label": "Murecho", "value": "Murecho, sans-serif"},
      {"label": "MuseoModerno", "value": "MuseoModerno, sans-serif"},
      {"label": "My Soul", "value": "'My Soul', cursive"},
      {"label": "Mynerve", "value": "Mynerve, cursive"},
      {"label": "Mystery Quest", "value": "'Mystery Quest', sans-serif"},
      {"label": "Nabla", "value": "Nabla, sans-serif"},
      {"label": "Namdhinggo", "value": "Namdhinggo, serif"},
      {"label": "Nanum Brush Script", "value": "'Nanum Brush Script', cursive"},
      {"label": "Nanum Gothic", "value": "'Nanum Gothic', sans-serif"},
      {"label": "Nanum Gothic Coding", "value": "'Nanum Gothic Coding', cursive"},
      {"label": "Nanum Myeongjo", "value": "'Nanum Myeongjo', serif"},
      {"label": "Nanum Pen Script", "value": "'Nanum Pen Script', cursive"},
      {"label": "Narnoor", "value": "Narnoor, sans-serif"},
      {"label": "Nata Sans", "value": "'Nata Sans', sans-serif"},
      {"label": "National Park", "value": "'National Park', sans-serif"},
      {"label": "Neonderthaw", "value": "Neonderthaw, cursive"},
      {"label": "Nerko One", "value": "'Nerko One', cursive"},
      {"label": "Neucha", "value": "Neucha, cursive"},
      {"label": "Neuton", "value": "Neuton, serif"},
      {"label": "New Amsterdam", "value": "'New Amsterdam', sans-serif"},
      {"label": "New Rocker", "value": "'New Rocker', sans-serif"},
      {"label": "New Tegomin", "value": "'New Tegomin', serif"},
      {"label": "News Cycle", "value": "'News Cycle', sans-serif"},
      {"label": "Newsreader", "value": "Newsreader, serif"},
      {"label": "Niconne", "value": "Niconne, cursive"},
      {"label": "Niramit", "value": "Niramit, sans-serif"},
      {"label": "Nixie One", "value": "'Nixie One', sans-serif"},
      {"label": "Nobile", "value": "Nobile, sans-serif"},
      {"label": "Nokora", "value": "Nokora, sans-serif"},
      {"label": "Norican", "value": "Norican, cursive"},
      {"label": "Nosifer", "value": "Nosifer, sans-serif"},
      {"label": "Notable", "value": "Notable, sans-serif"},
      {"label": "Nothing You Could Do", "value": "'Nothing You Could Do', cursive"},
      {"label": "Noticia Text", "value": "'Noticia Text', serif"},
      {"label": "Noto Color Emoji", "value": "'Noto Color Emoji', sans-serif"},
      {"label": "Noto Emoji", "value": "'Noto Emoji', sans-serif"},
      {"label": "Noto Kufi Arabic", "value": "'Noto Kufi Arabic', sans-serif"},
      {"label": "Noto Music", "value": "'Noto Music', sans-serif"},
      {"label": "Noto Naskh Arabic", "value": "'Noto Naskh Arabic', serif"},
      {"label": "Noto Nastaliq Urdu", "value": "'Noto Nastaliq Urdu', serif"},
      {"label": "Noto Rashi Hebrew", "value": "'Noto Rashi Hebrew', serif"},
      {"label": "Noto Sans", "value": "'Noto Sans', sans-serif"},
      {"label": "Noto Sans Adlam", "value": "'Noto Sans Adlam', sans-serif"},
      {"label": "Noto Sans Adlam Unjoined", "value": "'Noto Sans Adlam Unjoined', sans-serif"},
      {"label": "Noto Sans Anatolian Hieroglyphs", "value": "'Noto Sans Anatolian Hieroglyphs', sans-serif"},
      {"label": "Noto Sans Arabic", "value": "'Noto Sans Arabic', sans-serif"},
      {"label": "Noto Sans Armenian", "value": "'Noto Sans Armenian', sans-serif"},
      {"label": "Noto Sans Avestan", "value": "'Noto Sans Avestan', sans-serif"},
      {"label": "Noto Sans Balinese", "value": "'Noto Sans Balinese', sans-serif"},
      {"label": "Noto Sans Bamum", "value": "'Noto Sans Bamum', sans-serif"},
      {"label": "Noto Sans Bassa Vah", "value": "'Noto Sans Bassa Vah', sans-serif"},
      {"label": "Noto Sans Batak", "value": "'Noto Sans Batak', sans-serif"},
      {"label": "Noto Sans Bengali", "value": "'Noto Sans Bengali', sans-serif"},
      {"label": "Noto Sans Bhaiksuki", "value": "'Noto Sans Bhaiksuki', sans-serif"},
      {"label": "Noto Sans Brahmi", "value": "'Noto Sans Brahmi', sans-serif"},
      {"label": "Noto Sans Buginese", "value": "'Noto Sans Buginese', sans-serif"},
      {"label": "Noto Sans Buhid", "value": "'Noto Sans Buhid', sans-serif"},
      {"label": "Noto Sans Canadian Aboriginal", "value": "'Noto Sans Canadian Aboriginal', sans-serif"},
      {"label": "Noto Sans Carian", "value": "'Noto Sans Carian', sans-serif"},
      {"label": "Noto Sans Caucasian Albanian", "value": "'Noto Sans Caucasian Albanian', sans-serif"},
      {"label": "Noto Sans Chakma", "value": "'Noto Sans Chakma', sans-serif"},
      {"label": "Noto Sans Cham", "value": "'Noto Sans Cham', sans-serif"},
      {"label": "Noto Sans Cherokee", "value": "'Noto Sans Cherokee', sans-serif"},
      {"label": "Noto Sans Chorasmian", "value": "'Noto Sans Chorasmian', sans-serif"},
      {"label": "Noto Sans Coptic", "value": "'Noto Sans Coptic', sans-serif"},
      {"label": "Noto Sans Cuneiform", "value": "'Noto Sans Cuneiform', sans-serif"},
      {"label": "Noto Sans Cypriot", "value": "'Noto Sans Cypriot', sans-serif"},
      {"label": "Noto Sans Cypro Minoan", "value": "'Noto Sans Cypro Minoan', sans-serif"},
      {"label": "Noto Sans Deseret", "value": "'Noto Sans Deseret', sans-serif"},
      {"label": "Noto Sans Devanagari", "value": "'Noto Sans Devanagari', sans-serif"},
      {"label": "Noto Sans Display", "value": "'Noto Sans Display', sans-serif"},
      {"label": "Noto Sans Duployan", "value": "'Noto Sans Duployan', sans-serif"},
      {"label": "Noto Sans Egyptian Hieroglyphs", "value": "'Noto Sans Egyptian Hieroglyphs', sans-serif"},
      {"label": "Noto Sans Elbasan", "value": "'Noto Sans Elbasan', sans-serif"},
      {"label": "Noto Sans Elymaic", "value": "'Noto Sans Elymaic', sans-serif"},
      {"label": "Noto Sans Ethiopic", "value": "'Noto Sans Ethiopic', sans-serif"},
      {"label": "Noto Sans Georgian", "value": "'Noto Sans Georgian', sans-serif"},
      {"label": "Noto Sans Glagolitic", "value": "'Noto Sans Glagolitic', sans-serif"},
      {"label": "Noto Sans Gothic", "value": "'Noto Sans Gothic', sans-serif"},
      {"label": "Noto Sans Grantha", "value": "'Noto Sans Grantha', sans-serif"},
      {"label": "Noto Sans Gujarati", "value": "'Noto Sans Gujarati', sans-serif"},
      {"label": "Noto Sans Gunjala Gondi", "value": "'Noto Sans Gunjala Gondi', sans-serif"},
      {"label": "Noto Sans Gurmukhi", "value": "'Noto Sans Gurmukhi', sans-serif"},
      {"label": "Noto Sans Hanifi Rohingya", "value": "'Noto Sans Hanifi Rohingya', sans-serif"},
      {"label": "Noto Sans Hanunoo", "value": "'Noto Sans Hanunoo', sans-serif"},
      {"label": "Noto Sans Hatran", "value": "'Noto Sans Hatran', sans-serif"},
      {"label": "Noto Sans Hebrew", "value": "'Noto Sans Hebrew', sans-serif"},
      {"label": "Noto Sans HK", "value": "'Noto Sans HK', sans-serif"},
      {"label": "Noto Sans Imperial Aramaic", "value": "'Noto Sans Imperial Aramaic', sans-serif"},
      {"label": "Noto Sans Indic Siyaq Numbers", "value": "'Noto Sans Indic Siyaq Numbers', sans-serif"},
      {"label": "Noto Sans Inscriptional Pahlavi", "value": "'Noto Sans Inscriptional Pahlavi', sans-serif"},
      {"label": "Noto Sans Inscriptional Parthian", "value": "'Noto Sans Inscriptional Parthian', sans-serif"},
      {"label": "Noto Sans Javanese", "value": "'Noto Sans Javanese', sans-serif"},
      {"label": "Noto Sans JP", "value": "'Noto Sans JP', sans-serif"},
      {"label": "Noto Sans Kaithi", "value": "'Noto Sans Kaithi', sans-serif"},
      {"label": "Noto Sans Kannada", "value": "'Noto Sans Kannada', sans-serif"},
      {"label": "Noto Sans Kawi", "value": "'Noto Sans Kawi', sans-serif"},
      {"label": "Noto Sans Kayah Li", "value": "'Noto Sans Kayah Li', sans-serif"},
      {"label": "Noto Sans Kharoshthi", "value": "'Noto Sans Kharoshthi', sans-serif"},
      {"label": "Noto Sans Khmer", "value": "'Noto Sans Khmer', sans-serif"},
      {"label": "Noto Sans Khojki", "value": "'Noto Sans Khojki', sans-serif"},
      {"label": "Noto Sans Khudawadi", "value": "'Noto Sans Khudawadi', sans-serif"},
      {"label": "Noto Sans KR", "value": "'Noto Sans KR', sans-serif"},
      {"label": "Noto Sans Lao", "value": "'Noto Sans Lao', sans-serif"},
      {"label": "Noto Sans Lao Looped", "value": "'Noto Sans Lao Looped', sans-serif"},
      {"label": "Noto Sans Lepcha", "value": "'Noto Sans Lepcha', sans-serif"},
      {"label": "Noto Sans Limbu", "value": "'Noto Sans Limbu', sans-serif"},
      {"label": "Noto Sans Linear A", "value": "'Noto Sans Linear A', sans-serif"},
      {"label": "Noto Sans Linear B", "value": "'Noto Sans Linear B', sans-serif"},
      {"label": "Noto Sans Lisu", "value": "'Noto Sans Lisu', sans-serif"},
      {"label": "Noto Sans Lycian", "value": "'Noto Sans Lycian', sans-serif"},
      {"label": "Noto Sans Lydian", "value": "'Noto Sans Lydian', sans-serif"},
      {"label": "Noto Sans Mahajani", "value": "'Noto Sans Mahajani', sans-serif"},
      {"label": "Noto Sans Malayalam", "value": "'Noto Sans Malayalam', sans-serif"},
      {"label": "Noto Sans Mandaic", "value": "'Noto Sans Mandaic', sans-serif"},
      {"label": "Noto Sans Manichaean", "value": "'Noto Sans Manichaean', sans-serif"},
      {"label": "Noto Sans Marchen", "value": "'Noto Sans Marchen', sans-serif"},
      {"label": "Noto Sans Masaram Gondi", "value": "'Noto Sans Masaram Gondi', sans-serif"},
      {"label": "Noto Sans Math", "value": "'Noto Sans Math', sans-serif"},
      {"label": "Noto Sans Mayan Numerals", "value": "'Noto Sans Mayan Numerals', sans-serif"},
      {"label": "Noto Sans Medefaidrin", "value": "'Noto Sans Medefaidrin', sans-serif"},
      {"label": "Noto Sans Meetei Mayek", "value": "'Noto Sans Meetei Mayek', sans-serif"},
      {"label": "Noto Sans Mende Kikakui", "value": "'Noto Sans Mende Kikakui', sans-serif"},
      {"label": "Noto Sans Meroitic", "value": "'Noto Sans Meroitic', sans-serif"},
      {"label": "Noto Sans Miao", "value": "'Noto Sans Miao', sans-serif"},
      {"label": "Noto Sans Modi", "value": "'Noto Sans Modi', sans-serif"},
      {"label": "Noto Sans Mongolian", "value": "'Noto Sans Mongolian', sans-serif"},
      {"label": "Noto Sans Mono", "value": "'Noto Sans Mono', sans-serif"},
      {"label": "Noto Sans Mro", "value": "'Noto Sans Mro', sans-serif"},
      {"label": "Noto Sans Multani", "value": "'Noto Sans Multani', sans-serif"},
      {"label": "Noto Sans Myanmar", "value": "'Noto Sans Myanmar', sans-serif"},
      {"label": "Noto Sans Nabataean", "value": "'Noto Sans Nabataean', sans-serif"},
      {"label": "Noto Sans Nag Mundari", "value": "'Noto Sans Nag Mundari', sans-serif"},
      {"label": "Noto Sans Nandinagari", "value": "'Noto Sans Nandinagari', sans-serif"},
      {"label": "Noto Sans New Tai Lue", "value": "'Noto Sans New Tai Lue', sans-serif"},
      {"label": "Noto Sans Newa", "value": "'Noto Sans Newa', sans-serif"},
      {"label": "Noto Sans NKo", "value": "'Noto Sans NKo', sans-serif"},
      {"label": "Noto Sans NKo Unjoined", "value": "'Noto Sans NKo Unjoined', sans-serif"},
      {"label": "Noto Sans Nushu", "value": "'Noto Sans Nushu', sans-serif"},
      {"label": "Noto Sans Ogham", "value": "'Noto Sans Ogham', sans-serif"},
      {"label": "Noto Sans Ol Chiki", "value": "'Noto Sans Ol Chiki', sans-serif"},
      {"label": "Noto Sans Old Hungarian", "value": "'Noto Sans Old Hungarian', sans-serif"},
      {"label": "Noto Sans Old Italic", "value": "'Noto Sans Old Italic', sans-serif"},
      {"label": "Noto Sans Old North Arabian", "value": "'Noto Sans Old North Arabian', sans-serif"},
      {"label": "Noto Sans Old Permic", "value": "'Noto Sans Old Permic', sans-serif"},
      {"label": "Noto Sans Old Persian", "value": "'Noto Sans Old Persian', sans-serif"},
      {"label": "Noto Sans Old Sogdian", "value": "'Noto Sans Old Sogdian', sans-serif"},
      {"label": "Noto Sans Old South Arabian", "value": "'Noto Sans Old South Arabian', sans-serif"},
      {"label": "Noto Sans Old Turkic", "value": "'Noto Sans Old Turkic', sans-serif"},
      {"label": "Noto Sans Oriya", "value": "'Noto Sans Oriya', sans-serif"},
      {"label": "Noto Sans Osage", "value": "'Noto Sans Osage', sans-serif"},
      {"label": "Noto Sans Osmanya", "value": "'Noto Sans Osmanya', sans-serif"},
      {"label": "Noto Sans Pahawh Hmong", "value": "'Noto Sans Pahawh Hmong', sans-serif"},
      {"label": "Noto Sans Palmyrene", "value": "'Noto Sans Palmyrene', sans-serif"},
      {"label": "Noto Sans Pau Cin Hau", "value": "'Noto Sans Pau Cin Hau', sans-serif"},
      {"label": "Noto Sans PhagsPa", "value": "'Noto Sans PhagsPa', sans-serif"},
      {"label": "Noto Sans Phoenician", "value": "'Noto Sans Phoenician', sans-serif"},
      {"label": "Noto Sans Psalter Pahlavi", "value": "'Noto Sans Psalter Pahlavi', sans-serif"},
      {"label": "Noto Sans Rejang", "value": "'Noto Sans Rejang', sans-serif"},
      {"label": "Noto Sans Runic", "value": "'Noto Sans Runic', sans-serif"},
      {"label": "Noto Sans Samaritan", "value": "'Noto Sans Samaritan', sans-serif"},
      {"label": "Noto Sans Saurashtra", "value": "'Noto Sans Saurashtra', sans-serif"},
      {"label": "Noto Sans SC", "value": "'Noto Sans SC', sans-serif"},
      {"label": "Noto Sans Sharada", "value": "'Noto Sans Sharada', sans-serif"},
      {"label": "Noto Sans Shavian", "value": "'Noto Sans Shavian', sans-serif"},
      {"label": "Noto Sans Siddham", "value": "'Noto Sans Siddham', sans-serif"},
      {"label": "Noto Sans SignWriting", "value": "'Noto Sans SignWriting', sans-serif"},
      {"label": "Noto Sans Sinhala", "value": "'Noto Sans Sinhala', sans-serif"},
      {"label": "Noto Sans Sogdian", "value": "'Noto Sans Sogdian', sans-serif"},
      {"label": "Noto Sans Sora Sompeng", "value": "'Noto Sans Sora Sompeng', sans-serif"},
      {"label": "Noto Sans Soyombo", "value": "'Noto Sans Soyombo', sans-serif"},
      {"label": "Noto Sans Sundanese", "value": "'Noto Sans Sundanese', sans-serif"},
      {"label": "Noto Sans Sunuwar", "value": "'Noto Sans Sunuwar', sans-serif"},
      {"label": "Noto Sans Syloti Nagri", "value": "'Noto Sans Syloti Nagri', sans-serif"},
      {"label": "Noto Sans Symbols", "value": "'Noto Sans Symbols', sans-serif"},
      {"label": "Noto Sans Symbols 2", "value": "'Noto Sans Symbols 2', sans-serif"},
      {"label": "Noto Sans Syriac", "value": "'Noto Sans Syriac', sans-serif"},
      {"label": "Noto Sans Syriac Eastern", "value": "'Noto Sans Syriac Eastern', sans-serif"},
      {"label": "Noto Sans Syriac Western", "value": "'Noto Sans Syriac Western', sans-serif"},
      {"label": "Noto Sans Tagalog", "value": "'Noto Sans Tagalog', sans-serif"},
      {"label": "Noto Sans Tagbanwa", "value": "'Noto Sans Tagbanwa', sans-serif"},
      {"label": "Noto Sans Tai Le", "value": "'Noto Sans Tai Le', sans-serif"},
      {"label": "Noto Sans Tai Tham", "value": "'Noto Sans Tai Tham', sans-serif"},
      {"label": "Noto Sans Tai Viet", "value": "'Noto Sans Tai Viet', sans-serif"},
      {"label": "Noto Sans Takri", "value": "'Noto Sans Takri', sans-serif"},
      {"label": "Noto Sans Tamil", "value": "'Noto Sans Tamil', sans-serif"},
      {"label": "Noto Sans Tamil Supplement", "value": "'Noto Sans Tamil Supplement', sans-serif"},
      {"label": "Noto Sans Tangsa", "value": "'Noto Sans Tangsa', sans-serif"},
      {"label": "Noto Sans TC", "value": "'Noto Sans TC', sans-serif"},
      {"label": "Noto Sans Telugu", "value": "'Noto Sans Telugu', sans-serif"},
      {"label": "Noto Sans Thaana", "value": "'Noto Sans Thaana', sans-serif"},
      {"label": "Noto Sans Thai", "value": "'Noto Sans Thai', sans-serif"},
      {"label": "Noto Sans Thai Looped", "value": "'Noto Sans Thai Looped', sans-serif"},
      {"label": "Noto Sans Tifinagh", "value": "'Noto Sans Tifinagh', sans-serif"},
      {"label": "Noto Sans Tirhuta", "value": "'Noto Sans Tirhuta', sans-serif"},
      {"label": "Noto Sans Ugaritic", "value": "'Noto Sans Ugaritic', sans-serif"},
      {"label": "Noto Sans Vai", "value": "'Noto Sans Vai', sans-serif"},
      {"label": "Noto Sans Vithkuqi", "value": "'Noto Sans Vithkuqi', sans-serif"},
      {"label": "Noto Sans Wancho", "value": "'Noto Sans Wancho', sans-serif"},
      {"label": "Noto Sans Warang Citi", "value": "'Noto Sans Warang Citi', sans-serif"},
      {"label": "Noto Sans Yi", "value": "'Noto Sans Yi', sans-serif"},
      {"label": "Noto Sans Zanabazar Square", "value": "'Noto Sans Zanabazar Square', sans-serif"},
      {"label": "Noto Serif", "value": "'Noto Serif', serif"},
      {"label": "Noto Serif Ahom", "value": "'Noto Serif Ahom', serif"},
      {"label": "Noto Serif Armenian", "value": "'Noto Serif Armenian', serif"},
      {"label": "Noto Serif Balinese", "value": "'Noto Serif Balinese', serif"},
      {"label": "Noto Serif Bengali", "value": "'Noto Serif Bengali', serif"},
      {"label": "Noto Serif Devanagari", "value": "'Noto Serif Devanagari', serif"},
      {"label": "Noto Serif Display", "value": "'Noto Serif Display', serif"},
      {"label": "Noto Serif Dives Akuru", "value": "'Noto Serif Dives Akuru', serif"},
      {"label": "Noto Serif Dogra", "value": "'Noto Serif Dogra', serif"},
      {"label": "Noto Serif Ethiopic", "value": "'Noto Serif Ethiopic', serif"},
      {"label": "Noto Serif Georgian", "value": "'Noto Serif Georgian', serif"},
      {"label": "Noto Serif Grantha", "value": "'Noto Serif Grantha', serif"},
      {"label": "Noto Serif Gujarati", "value": "'Noto Serif Gujarati', serif"},
      {"label": "Noto Serif Gurmukhi", "value": "'Noto Serif Gurmukhi', serif"},
      {"label": "Noto Serif Hebrew", "value": "'Noto Serif Hebrew', serif"},
      {"label": "Noto Serif Hentaigana", "value": "'Noto Serif Hentaigana', serif"},
      {"label": "Noto Serif HK", "value": "'Noto Serif HK', serif"},
      {"label": "Noto Serif JP", "value": "'Noto Serif JP', serif"},
      {"label": "Noto Serif Kannada", "value": "'Noto Serif Kannada', serif"},
      {"label": "Noto Serif Khitan Small Script", "value": "'Noto Serif Khitan Small Script', serif"},
      {"label": "Noto Serif Khmer", "value": "'Noto Serif Khmer', serif"},
      {"label": "Noto Serif Khojki", "value": "'Noto Serif Khojki', serif"},
      {"label": "Noto Serif KR", "value": "'Noto Serif KR', serif"},
      {"label": "Noto Serif Lao", "value": "'Noto Serif Lao', serif"},
      {"label": "Noto Serif Makasar", "value": "'Noto Serif Makasar', serif"},
      {"label": "Noto Serif Malayalam", "value": "'Noto Serif Malayalam', serif"},
      {"label": "Noto Serif Myanmar", "value": "'Noto Serif Myanmar', serif"},
      {"label": "Noto Serif NP Hmong", "value": "'Noto Serif NP Hmong', serif"},
      {"label": "Noto Serif Old Uyghur", "value": "'Noto Serif Old Uyghur', serif"},
      {"label": "Noto Serif Oriya", "value": "'Noto Serif Oriya', serif"},
      {"label": "Noto Serif Ottoman Siyaq", "value": "'Noto Serif Ottoman Siyaq', serif"},
      {"label": "Noto Serif SC", "value": "'Noto Serif SC', serif"},
      {"label": "Noto Serif Sinhala", "value": "'Noto Serif Sinhala', serif"},
      {"label": "Noto Serif Tamil", "value": "'Noto Serif Tamil', serif"},
      {"label": "Noto Serif Tangut", "value": "'Noto Serif Tangut', serif"},
      {"label": "Noto Serif TC", "value": "'Noto Serif TC', serif"},
      {"label": "Noto Serif Telugu", "value": "'Noto Serif Telugu', serif"},
      {"label": "Noto Serif Thai", "value": "'Noto Serif Thai', serif"},
      {"label": "Noto Serif Tibetan", "value": "'Noto Serif Tibetan', serif"},
      {"label": "Noto Serif Todhri", "value": "'Noto Serif Todhri', serif"},
      {"label": "Noto Serif Toto", "value": "'Noto Serif Toto', serif"},
      {"label": "Noto Serif Vithkuqi", "value": "'Noto Serif Vithkuqi', serif"},
      {"label": "Noto Serif Yezidi", "value": "'Noto Serif Yezidi', serif"},
      {"label": "Noto Traditional Nushu", "value": "'Noto Traditional Nushu', sans-serif"},
      {"label": "Noto Znamenny Musical Notation", "value": "'Noto Znamenny Musical Notation', sans-serif"},
      {"label": "Nova Cut", "value": "'Nova Cut', sans-serif"},
      {"label": "Nova Flat", "value": "'Nova Flat', sans-serif"},
      {"label": "Nova Mono", "value": "'Nova Mono', monospace"},
      {"label": "Nova Oval", "value": "'Nova Oval', sans-serif"},
      {"label": "Nova Round", "value": "'Nova Round', sans-serif"},
      {"label": "Nova Script", "value": "'Nova Script', sans-serif"},
      {"label": "Nova Slim", "value": "'Nova Slim', sans-serif"},
      {"label": "Nova Square", "value": "'Nova Square', sans-serif"},
      {"label": "NTR", "value": "NTR, sans-serif"},
      {"label": "Numans", "value": "Numans, sans-serif"},
      {"label": "Nunito", "value": "Nunito, sans-serif"},
      {"label": "Nunito Sans", "value": "'Nunito Sans', sans-serif"},
      {"label": "Nuosu SIL", "value": "'Nuosu SIL', sans-serif"},
      {"label": "Odibee Sans", "value": "'Odibee Sans', sans-serif"},
      {"label": "Odor Mean Chey", "value": "'Odor Mean Chey', serif"},
      {"label": "Offside", "value": "Offside, sans-serif"},
      {"label": "Oi", "value": "Oi, sans-serif"},
      {"label": "Ojuju", "value": "Ojuju, sans-serif"},
      {"label": "Old Standard TT", "value": "'Old Standard TT', serif"},
      {"label": "Oldenburg", "value": "Oldenburg, sans-serif"},
      {"label": "Ole", "value": "Ole, cursive"},
      {"label": "Oleo Script", "value": "'Oleo Script', sans-serif"},
      {"label": "Oleo Script Swash Caps", "value": "'Oleo Script Swash Caps', sans-serif"},
      {"label": "Onest", "value": "Onest, sans-serif"},
      {"label": "Oooh Baby", "value": "'Oooh Baby', cursive"},
      {"label": "Open Sans", "value": "'Open Sans', sans-serif"},
      {"label": "Oranienbaum", "value": "Oranienbaum, serif"},
      {"label": "Orbit", "value": "Orbit, sans-serif"},
      {"label": "Orbitron", "value": "Orbitron, sans-serif"},
      {"label": "Oregano", "value": "Oregano, sans-serif"},
      {"label": "Orelega One", "value": "'Orelega One', sans-serif"},
      {"label": "Orienta", "value": "Orienta, sans-serif"},
      {"label": "Original Surfer", "value": "'Original Surfer', sans-serif"},
      {"label": "Oswald", "value": "Oswald, sans-serif"},
      {"label": "Outfit", "value": "Outfit, sans-serif"},
      {"label": "Over the Rainbow", "value": "'Over the Rainbow', cursive"},
      {"label": "Overlock", "value": "Overlock, sans-serif"},
      {"label": "Overlock SC", "value": "'Overlock SC', sans-serif"},
      {"label": "Overpass", "value": "Overpass, sans-serif"},
      {"label": "Overpass Mono", "value": "'Overpass Mono', monospace"},
      {"label": "Ovo", "value": "Ovo, serif"},
      {"label": "Oxanium", "value": "Oxanium, sans-serif"},
      {"label": "Oxygen", "value": "Oxygen, sans-serif"},
      {"label": "Oxygen Mono", "value": "'Oxygen Mono', monospace"},
      {"label": "Pacifico", "value": "Pacifico, cursive"},
      {"label": "Padauk", "value": "Padauk, sans-serif"},
      {"label": "Padyakke Expanded One", "value": "'Padyakke Expanded One', serif"},
      {"label": "Palanquin", "value": "Palanquin, sans-serif"},
      {"label": "Palanquin Dark", "value": "'Palanquin Dark', sans-serif"},
      {"label": "Palette Mosaic", "value": "'Palette Mosaic', sans-serif"},
      {"label": "Pangolin", "value": "Pangolin, cursive"},
      {"label": "Paprika", "value": "Paprika, sans-serif"},
      {"label": "Parastoo", "value": "Parastoo, serif"},
      {"label": "Parisienne", "value": "Parisienne, cursive"},
      {"label": "Parkinsans", "value": "Parkinsans, sans-serif"},
      {"label": "Passero One", "value": "'Passero One', sans-serif"},
      {"label": "Passion One", "value": "'Passion One', sans-serif"},
      {"label": "Passions Conflict", "value": "'Passions Conflict', cursive"},
      {"label": "Pathway Extreme", "value": "'Pathway Extreme', sans-serif"},
      {"label": "Pathway Gothic One", "value": "'Pathway Gothic One', sans-serif"},
      {"label": "Patrick Hand", "value": "'Patrick Hand', cursive"},
      {"label": "Patrick Hand SC", "value": "'Patrick Hand SC', cursive"},
      {"label": "Pattaya", "value": "Pattaya, sans-serif"},
      {"label": "Patua One", "value": "'Patua One', sans-serif"},
      {"label": "Pavanam", "value": "Pavanam, sans-serif"},
      {"label": "Paytone One", "value": "'Paytone One', sans-serif"},
      {"label": "Peddana", "value": "Peddana, serif"},
      {"label": "Peralta", "value": "Peralta, serif"},
      {"label": "Permanent Marker", "value": "'Permanent Marker', cursive"},
      {"label": "Petemoss", "value": "Petemoss, cursive"},
      {"label": "Petit Formal Script", "value": "'Petit Formal Script', cursive"},
      {"label": "Petrona", "value": "Petrona, serif"},
      {"label": "Phetsarath", "value": "Phetsarath, sans-serif"},
      {"label": "Philosopher", "value": "Philosopher, sans-serif"},
      {"label": "Phudu", "value": "Phudu, sans-serif"},
      {"label": "Piazzolla", "value": "Piazzolla, serif"},
      {"label": "Piedra", "value": "Piedra, sans-serif"},
      {"label": "Pinyon Script", "value": "'Pinyon Script', cursive"},
      {"label": "Pirata One", "value": "'Pirata One', sans-serif"},
      {"label": "Pixelify Sans", "value": "'Pixelify Sans', sans-serif"},
      {"label": "Plaster", "value": "Plaster, sans-serif"},
      {"label": "Platypi", "value": "Platypi, serif"},
      {"label": "Play", "value": "Play, sans-serif"},
      {"label": "Playball", "value": "Playball, sans-serif"},
      {"label": "Playfair", "value": "Playfair, serif"},
      {"label": "Playfair Display", "value": "'Playfair Display', serif"},
      {"label": "Playfair Display SC", "value": "'Playfair Display SC', serif"},
      {"label": "Playpen Sans", "value": "'Playpen Sans', cursive"},
      {"label": "Playpen Sans Arabic", "value": "'Playpen Sans Arabic', cursive"},
      {"label": "Playpen Sans Deva", "value": "'Playpen Sans Deva', cursive"},
      {"label": "Playpen Sans Hebrew", "value": "'Playpen Sans Hebrew', cursive"},
      {"label": "Playpen Sans Thai", "value": "'Playpen Sans Thai', cursive"},
      {"label": "Playwrite AR", "value": "'Playwrite AR', cursive"},
      {"label": "Playwrite AR Guides", "value": "'Playwrite AR Guides', cursive"},
      {"label": "Playwrite AT", "value": "'Playwrite AT', cursive"},
      {"label": "Playwrite AT Guides", "value": "'Playwrite AT Guides', cursive"},
      {"label": "Playwrite AU NSW", "value": "'Playwrite AU NSW', cursive"},
      {"label": "Playwrite AU NSW Guides", "value": "'Playwrite AU NSW Guides', cursive"},
      {"label": "Playwrite AU QLD", "value": "'Playwrite AU QLD', cursive"},
      {"label": "Playwrite AU QLD Guides", "value": "'Playwrite AU QLD Guides', cursive"},
      {"label": "Playwrite AU SA", "value": "'Playwrite AU SA', cursive"},
      {"label": "Playwrite AU SA Guides", "value": "'Playwrite AU SA Guides', cursive"},
      {"label": "Playwrite AU TAS", "value": "'Playwrite AU TAS', cursive"},
      {"label": "Playwrite AU TAS Guides", "value": "'Playwrite AU TAS Guides', cursive"},
      {"label": "Playwrite AU VIC", "value": "'Playwrite AU VIC', cursive"},
      {"label": "Playwrite AU VIC Guides", "value": "'Playwrite AU VIC Guides', cursive"},
      {"label": "Playwrite BE VLG", "value": "'Playwrite BE VLG', cursive"},
      {"label": "Playwrite BE VLG Guides", "value": "'Playwrite BE VLG Guides', cursive"},
      {"label": "Playwrite BE WAL", "value": "'Playwrite BE WAL', cursive"},
      {"label": "Playwrite BE WAL Guides", "value": "'Playwrite BE WAL Guides', cursive"},
      {"label": "Playwrite BR", "value": "'Playwrite BR', cursive"},
      {"label": "Playwrite BR Guides", "value": "'Playwrite BR Guides', cursive"},
      {"label": "Playwrite CA", "value": "'Playwrite CA', cursive"},
      {"label": "Playwrite CA Guides", "value": "'Playwrite CA Guides', cursive"},
      {"label": "Playwrite CL", "value": "'Playwrite CL', cursive"},
      {"label": "Playwrite CL Guides", "value": "'Playwrite CL Guides', cursive"},
      {"label": "Playwrite CO", "value": "'Playwrite CO', cursive"},
      {"label": "Playwrite CO Guides", "value": "'Playwrite CO Guides', cursive"},
      {"label": "Playwrite CU", "value": "'Playwrite CU', cursive"},
      {"label": "Playwrite CU Guides", "value": "'Playwrite CU Guides', cursive"},
      {"label": "Playwrite CZ", "value": "'Playwrite CZ', cursive"},
      {"label": "Playwrite CZ Guides", "value": "'Playwrite CZ Guides', cursive"},
      {"label": "Playwrite DE Grund", "value": "'Playwrite DE Grund', cursive"},
      {"label": "Playwrite DE Grund Guides", "value": "'Playwrite DE Grund Guides', cursive"},
      {"label": "Playwrite DE LA", "value": "'Playwrite DE LA', cursive"},
      {"label": "Playwrite DE LA Guides", "value": "'Playwrite DE LA Guides', cursive"},
      {"label": "Playwrite DE SAS", "value": "'Playwrite DE SAS', cursive"},
      {"label": "Playwrite DE SAS Guides", "value": "'Playwrite DE SAS Guides', cursive"},
      {"label": "Playwrite DE VA", "value": "'Playwrite DE VA', cursive"},
      {"label": "Playwrite DE VA Guides", "value": "'Playwrite DE VA Guides', cursive"},
      {"label": "Playwrite DK Loopet", "value": "'Playwrite DK Loopet', cursive"},
      {"label": "Playwrite DK Loopet Guides", "value": "'Playwrite DK Loopet Guides', cursive"},
      {"label": "Playwrite DK Uloopet", "value": "'Playwrite DK Uloopet', cursive"},
      {"label": "Playwrite DK Uloopet Guides", "value": "'Playwrite DK Uloopet Guides', cursive"},
      {"label": "Playwrite ES", "value": "'Playwrite ES', cursive"},
      {"label": "Playwrite ES Deco", "value": "'Playwrite ES Deco', cursive"},
      {"label": "Playwrite ES Deco Guides", "value": "'Playwrite ES Deco Guides', cursive"},
      {"label": "Playwrite ES Guides", "value": "'Playwrite ES Guides', cursive"},
      {"label": "Playwrite FR Moderne", "value": "'Playwrite FR Moderne', cursive"},
      {"label": "Playwrite FR Moderne Guides", "value": "'Playwrite FR Moderne Guides', cursive"},
      {"label": "Playwrite FR Trad", "value": "'Playwrite FR Trad', cursive"},
      {"label": "Playwrite FR Trad Guides", "value": "'Playwrite FR Trad Guides', cursive"},
      {"label": "Playwrite GB J", "value": "'Playwrite GB J', cursive"},
      {"label": "Playwrite GB J Guides", "value": "'Playwrite GB J Guides', cursive"},
      {"label": "Playwrite GB S", "value": "'Playwrite GB S', cursive"},
      {"label": "Playwrite GB S Guides", "value": "'Playwrite GB S Guides', cursive"},
      {"label": "Playwrite HR", "value": "'Playwrite HR', cursive"},
      {"label": "Playwrite HR Guides", "value": "'Playwrite HR Guides', cursive"},
      {"label": "Playwrite HR Lijeva", "value": "'Playwrite HR Lijeva', cursive"},
      {"label": "Playwrite HR Lijeva Guides", "value": "'Playwrite HR Lijeva Guides', cursive"},
      {"label": "Playwrite HU", "value": "'Playwrite HU', cursive"},
      {"label": "Playwrite HU Guides", "value": "'Playwrite HU Guides', cursive"},
      {"label": "Playwrite ID", "value": "'Playwrite ID', cursive"},
      {"label": "Playwrite ID Guides", "value": "'Playwrite ID Guides', cursive"},
      {"label": "Playwrite IE", "value": "'Playwrite IE', cursive"},
      {"label": "Playwrite IE Guides", "value": "'Playwrite IE Guides', cursive"},
      {"label": "Playwrite IN", "value": "'Playwrite IN', cursive"},
      {"label": "Playwrite IN Guides", "value": "'Playwrite IN Guides', cursive"},
      {"label": "Playwrite IS", "value": "'Playwrite IS', cursive"},
      {"label": "Playwrite IS Guides", "value": "'Playwrite IS Guides', cursive"},
      {"label": "Playwrite IT Moderna", "value": "'Playwrite IT Moderna', cursive"},
      {"label": "Playwrite IT Moderna Guides", "value": "'Playwrite IT Moderna Guides', cursive"},
      {"label": "Playwrite IT Trad", "value": "'Playwrite IT Trad', cursive"},
      {"label": "Playwrite IT Trad Guides", "value": "'Playwrite IT Trad Guides', cursive"},
      {"label": "Playwrite MX", "value": "'Playwrite MX', cursive"},
      {"label": "Playwrite MX Guides", "value": "'Playwrite MX Guides', cursive"},
      {"label": "Playwrite NG Modern", "value": "'Playwrite NG Modern', cursive"},
      {"label": "Playwrite NG Modern Guides", "value": "'Playwrite NG Modern Guides', cursive"},
      {"label": "Playwrite NL", "value": "'Playwrite NL', cursive"},
      {"label": "Playwrite NL Guides", "value": "'Playwrite NL Guides', cursive"},
      {"label": "Playwrite NO", "value": "'Playwrite NO', cursive"},
      {"label": "Playwrite NO Guides", "value": "'Playwrite NO Guides', cursive"},
      {"label": "Playwrite NZ", "value": "'Playwrite NZ', cursive"},
      {"label": "Playwrite NZ Basic", "value": "'Playwrite NZ Basic', cursive"},
      {"label": "Playwrite NZ Basic Guides", "value": "'Playwrite NZ Basic Guides', cursive"},
      {"label": "Playwrite NZ Guides", "value": "'Playwrite NZ Guides', cursive"},
      {"label": "Playwrite PE", "value": "'Playwrite PE', cursive"},
      {"label": "Playwrite PE Guides", "value": "'Playwrite PE Guides', cursive"},
      {"label": "Playwrite PL", "value": "'Playwrite PL', cursive"},
      {"label": "Playwrite PL Guides", "value": "'Playwrite PL Guides', cursive"},
      {"label": "Playwrite PT", "value": "'Playwrite PT', cursive"},
      {"label": "Playwrite PT Guides", "value": "'Playwrite PT Guides', cursive"},
      {"label": "Playwrite RO", "value": "'Playwrite RO', cursive"},
      {"label": "Playwrite RO Guides", "value": "'Playwrite RO Guides', cursive"},
      {"label": "Playwrite SK", "value": "'Playwrite SK', cursive"},
      {"label": "Playwrite SK Guides", "value": "'Playwrite SK Guides', cursive"},
      {"label": "Playwrite TZ", "value": "'Playwrite TZ', cursive"},
      {"label": "Playwrite TZ Guides", "value": "'Playwrite TZ Guides', cursive"},
      {"label": "Playwrite US Modern", "value": "'Playwrite US Modern', cursive"},
      {"label": "Playwrite US Modern Guides", "value": "'Playwrite US Modern Guides', cursive"},
      {"label": "Playwrite US Trad", "value": "'Playwrite US Trad', cursive"},
      {"label": "Playwrite US Trad Guides", "value": "'Playwrite US Trad Guides', cursive"},
      {"label": "Playwrite VN", "value": "'Playwrite VN', cursive"},
      {"label": "Playwrite VN Guides", "value": "'Playwrite VN Guides', cursive"},
      {"label": "Playwrite ZA", "value": "'Playwrite ZA', cursive"},
      {"label": "Playwrite ZA Guides", "value": "'Playwrite ZA Guides', cursive"},
      {"label": "Pliant", "value": "Pliant, sans-serif"},
      {"label": "Plus Jakarta Sans", "value": "'Plus Jakarta Sans', sans-serif"},
      {"label": "Pochaevsk", "value": "Pochaevsk, sans-serif"},
      {"label": "Podkova", "value": "Podkova, serif"},
      {"label": "Poetsen One", "value": "'Poetsen One', sans-serif"},
      {"label": "Poiret One", "value": "'Poiret One', sans-serif"},
      {"label": "Poller One", "value": "'Poller One', sans-serif"},
      {"label": "Poltawski Nowy", "value": "'Poltawski Nowy', serif"},
      {"label": "Poly", "value": "Poly, serif"},
      {"label": "Pompiere", "value": "Pompiere, sans-serif"},
      {"label": "Ponnala", "value": "Ponnala, sans-serif"},
      {"label": "Ponomar", "value": "Ponomar, sans-serif"},
      {"label": "Pontano Sans", "value": "'Pontano Sans', sans-serif"},
      {"label": "Poor Story", "value": "'Poor Story', sans-serif"},
      {"label": "Poppins", "value": "Poppins, sans-serif"},
      {"label": "Port Lligat Sans", "value": "'Port Lligat Sans', sans-serif"},
      {"label": "Port Lligat Slab", "value": "'Port Lligat Slab', serif"},
      {"label": "Potta One", "value": "'Potta One', sans-serif"},
      {"label": "Pragati Narrow", "value": "'Pragati Narrow', sans-serif"},
      {"label": "Praise", "value": "Praise, cursive"},
      {"label": "Prata", "value": "Prata, serif"},
      {"label": "Preahvihear", "value": "Preahvihear, sans-serif"},
      {"label": "Press Start 2P", "value": "'Press Start 2P', sans-serif"},
      {"label": "Pridi", "value": "Pridi, serif"},
      {"label": "Princess Sofia", "value": "'Princess Sofia', cursive"},
      {"label": "Prociono", "value": "Prociono, serif"},
      {"label": "Prompt", "value": "Prompt, sans-serif"},
      {"label": "Prosto One", "value": "'Prosto One', sans-serif"},
      {"label": "Protest Guerrilla", "value": "'Protest Guerrilla', sans-serif"},
      {"label": "Protest Revolution", "value": "'Protest Revolution', sans-serif"},
      {"label": "Protest Riot", "value": "'Protest Riot', sans-serif"},
      {"label": "Protest Strike", "value": "'Protest Strike', sans-serif"},
      {"label": "Proza Libre", "value": "'Proza Libre', sans-serif"},
      {"label": "PT Mono", "value": "'PT Mono', monospace"},
      {"label": "PT Sans", "value": "'PT Sans', sans-serif"},
      {"label": "PT Sans Caption", "value": "'PT Sans Caption', sans-serif"},
      {"label": "PT Sans Narrow", "value": "'PT Sans Narrow', sans-serif"},
      {"label": "PT Serif", "value": "'PT Serif', serif"},
      {"label": "PT Serif Caption", "value": "'PT Serif Caption', serif"},
      {"label": "Public Sans", "value": "'Public Sans', sans-serif"},
      {"label": "Puppies Play", "value": "'Puppies Play', cursive"},
      {"label": "Puritan", "value": "Puritan, sans-serif"},
      {"label": "Purple Purse", "value": "'Purple Purse', sans-serif"},
      {"label": "Qahiri", "value": "Qahiri, sans-serif"},
      {"label": "Quando", "value": "Quando, serif"},
      {"label": "Quantico", "value": "Quantico, sans-serif"},
      {"label": "Quattrocento", "value": "Quattrocento, serif"},
      {"label": "Quattrocento Sans", "value": "'Quattrocento Sans', sans-serif"},
      {"label": "Questrial", "value": "Questrial, sans-serif"},
      {"label": "Quicksand", "value": "Quicksand, sans-serif"},
      {"label": "Quintessential", "value": "Quintessential, cursive"},
      {"label": "Qwigley", "value": "Qwigley, cursive"},
      {"label": "Qwitcher Grypen", "value": "'Qwitcher Grypen', cursive"},
      {"label": "Racing Sans One", "value": "'Racing Sans One', sans-serif"},
      {"label": "Radio Canada", "value": "'Radio Canada', sans-serif"},
      {"label": "Radio Canada Big", "value": "'Radio Canada Big', sans-serif"},
      {"label": "Radley", "value": "Radley, serif"},
      {"label": "Rajdhani", "value": "Rajdhani, sans-serif"},
      {"label": "Rakkas", "value": "Rakkas, sans-serif"},
      {"label": "Raleway", "value": "Raleway, sans-serif"},
      {"label": "Raleway Dots", "value": "'Raleway Dots', sans-serif"},
      {"label": "Ramabhadra", "value": "Ramabhadra, sans-serif"},
      {"label": "Ramaraja", "value": "Ramaraja, serif"},
      {"label": "Rambla", "value": "Rambla, sans-serif"},
      {"label": "Rammetto One", "value": "'Rammetto One', sans-serif"},
      {"label": "Rampart One", "value": "'Rampart One', sans-serif"},
      {"label": "Ramsina", "value": "Ramsina, serif"},
      {"label": "Ranchers", "value": "Ranchers, sans-serif"},
      {"label": "Rancho", "value": "Rancho, cursive"},
      {"label": "Ranga", "value": "Ranga, sans-serif"},
      {"label": "Rasa", "value": "Rasa, serif"},
      {"label": "Rationale", "value": "Rationale, sans-serif"},
      {"label": "Ravi Prakash", "value": "'Ravi Prakash', sans-serif"},
      {"label": "Readex Pro", "value": "'Readex Pro', sans-serif"},
      {"label": "Recursive", "value": "Recursive, sans-serif"},
      {"label": "Red Hat Display", "value": "'Red Hat Display', sans-serif"},
      {"label": "Red Hat Mono", "value": "'Red Hat Mono', monospace"},
      {"label": "Red Hat Text", "value": "'Red Hat Text', sans-serif"},
      {"label": "Red Rose", "value": "'Red Rose', sans-serif"},
      {"label": "Redacted", "value": "Redacted, sans-serif"},
      {"label": "Redacted Script", "value": "'Redacted Script', sans-serif"},
      {"label": "Reddit Mono", "value": "'Reddit Mono', monospace"},
      {"label": "Reddit Sans", "value": "'Reddit Sans', sans-serif"},
      {"label": "Reddit Sans Condensed", "value": "'Reddit Sans Condensed', sans-serif"},
      {"label": "Redressed", "value": "Redressed, cursive"},
      {"label": "Reem Kufi", "value": "'Reem Kufi', sans-serif"},
      {"label": "Reem Kufi Fun", "value": "'Reem Kufi Fun', sans-serif"},
      {"label": "Reem Kufi Ink", "value": "'Reem Kufi Ink', sans-serif"},
      {"label": "Reenie Beanie", "value": "'Reenie Beanie', cursive"},
      {"label": "Reggae One", "value": "'Reggae One', sans-serif"},
      {"label": "REM", "value": "REM, sans-serif"},
      {"label": "Rethink Sans", "value": "'Rethink Sans', sans-serif"},
      {"label": "Revalia", "value": "Revalia, sans-serif"},
      {"label": "Rhodium Libre", "value": "'Rhodium Libre', serif"},
      {"label": "Ribeye", "value": "Ribeye, sans-serif"},
      {"label": "Ribeye Marrow", "value": "'Ribeye Marrow', sans-serif"},
      {"label": "Righteous", "value": "Righteous, sans-serif"},
      {"label": "Risque", "value": "Risque, sans-serif"},
      {"label": "Road Rage", "value": "'Road Rage', sans-serif"},
      {"label": "Roboto", "value": "Roboto, 'Segoe UI', sans-serif"},
      {"label": "Roboto Condensed", "value": "'Roboto Condensed', sans-serif"},
      {"label": "Roboto Flex", "value": "'Roboto Flex', sans-serif"},
      {"label": "Roboto Mono", "value": "'Roboto Mono', monospace"},
      {"label": "Roboto Serif", "value": "'Roboto Serif', serif"},
      {"label": "Roboto Slab", "value": "'Roboto Slab', serif"},
      {"label": "Rochester", "value": "Rochester, cursive"},
      {"label": "Rock 3D", "value": "'Rock 3D', sans-serif"},
      {"label": "Rock Salt", "value": "'Rock Salt', cursive"},
      {"label": "RocknRoll One", "value": "'RocknRoll One', sans-serif"},
      {"label": "Rokkitt", "value": "Rokkitt, serif"},
      {"label": "Romanesco", "value": "Romanesco, cursive"},
      {"label": "Ropa Sans", "value": "'Ropa Sans', sans-serif"},
      {"label": "Rosario", "value": "Rosario, sans-serif"},
      {"label": "Rosarivo", "value": "Rosarivo, serif"},
      {"label": "Rouge Script", "value": "'Rouge Script', cursive"},
      {"label": "Rowdies", "value": "Rowdies, sans-serif"},
      {"label": "Rozha One", "value": "'Rozha One', serif"},
      {"label": "Rubik", "value": "Rubik, sans-serif"},
      {"label": "Rubik 80s Fade", "value": "'Rubik 80s Fade', sans-serif"},
      {"label": "Rubik Beastly", "value": "'Rubik Beastly', sans-serif"},
      {"label": "Rubik Broken Fax", "value": "'Rubik Broken Fax', sans-serif"},
      {"label": "Rubik Bubbles", "value": "'Rubik Bubbles', sans-serif"},
      {"label": "Rubik Burned", "value": "'Rubik Burned', sans-serif"},
      {"label": "Rubik Dirt", "value": "'Rubik Dirt', sans-serif"},
      {"label": "Rubik Distressed", "value": "'Rubik Distressed', sans-serif"},
      {"label": "Rubik Doodle Shadow", "value": "'Rubik Doodle Shadow', sans-serif"},
      {"label": "Rubik Doodle Triangles", "value": "'Rubik Doodle Triangles', sans-serif"},
      {"label": "Rubik Gemstones", "value": "'Rubik Gemstones', sans-serif"},
      {"label": "Rubik Glitch", "value": "'Rubik Glitch', sans-serif"},
      {"label": "Rubik Glitch Pop", "value": "'Rubik Glitch Pop', sans-serif"},
      {"label": "Rubik Iso", "value": "'Rubik Iso', sans-serif"},
      {"label": "Rubik Lines", "value": "'Rubik Lines', sans-serif"},
      {"label": "Rubik Maps", "value": "'Rubik Maps', sans-serif"},
      {"label": "Rubik Marker Hatch", "value": "'Rubik Marker Hatch', sans-serif"},
      {"label": "Rubik Maze", "value": "'Rubik Maze', sans-serif"},
      {"label": "Rubik Microbe", "value": "'Rubik Microbe', sans-serif"},
      {"label": "Rubik Mono One", "value": "'Rubik Mono One', sans-serif"},
      {"label": "Rubik Moonrocks", "value": "'Rubik Moonrocks', sans-serif"},
      {"label": "Rubik Pixels", "value": "'Rubik Pixels', sans-serif"},
      {"label": "Rubik Puddles", "value": "'Rubik Puddles', sans-serif"},
      {"label": "Rubik Scribble", "value": "'Rubik Scribble', sans-serif"},
      {"label": "Rubik Spray Paint", "value": "'Rubik Spray Paint', sans-serif"},
      {"label": "Rubik Storm", "value": "'Rubik Storm', sans-serif"},
      {"label": "Rubik Vinyl", "value": "'Rubik Vinyl', sans-serif"},
      {"label": "Rubik Wet Paint", "value": "'Rubik Wet Paint', sans-serif"},
      {"label": "Ruda", "value": "Ruda, sans-serif"},
      {"label": "Rufina", "value": "Rufina, serif"},
      {"label": "Ruge Boogie", "value": "'Ruge Boogie', cursive"},
      {"label": "Ruluko", "value": "Ruluko, sans-serif"},
      {"label": "Rum Raisin", "value": "'Rum Raisin', sans-serif"},
      {"label": "Ruslan Display", "value": "'Ruslan Display', sans-serif"},
      {"label": "Russo One", "value": "'Russo One', sans-serif"},
      {"label": "Ruthie", "value": "Ruthie, cursive"},
      {"label": "Ruwudu", "value": "Ruwudu, serif"},
      {"label": "Rye", "value": "Rye, sans-serif"},
      {"label": "Sacramento", "value": "Sacramento, cursive"},
      {"label": "Sahitya", "value": "Sahitya, serif"},
      {"label": "Sail", "value": "Sail, sans-serif"},
      {"label": "Saira", "value": "Saira, sans-serif"},
      {"label": "Saira Condensed", "value": "'Saira Condensed', sans-serif"},
      {"label": "Saira Extra Condensed", "value": "'Saira Extra Condensed', sans-serif"},
      {"label": "Saira Semi Condensed", "value": "'Saira Semi Condensed', sans-serif"},
      {"label": "Saira Stencil", "value": "'Saira Stencil', sans-serif"},
      {"label": "Salsa", "value": "Salsa, sans-serif"},
      {"label": "Sanchez", "value": "Sanchez, serif"},
      {"label": "Sancreek", "value": "Sancreek, sans-serif"},
      {"label": "Sankofa Display", "value": "'Sankofa Display', sans-serif"},
      {"label": "Sansation", "value": "Sansation, sans-serif"},
      {"label": "Sansita", "value": "Sansita, sans-serif"},
      {"label": "Sansita Swashed", "value": "'Sansita Swashed', sans-serif"},
      {"label": "Sarabun", "value": "Sarabun, sans-serif"},
      {"label": "Sarala", "value": "Sarala, sans-serif"},
      {"label": "Sarina", "value": "Sarina, sans-serif"},
      {"label": "Sarpanch", "value": "Sarpanch, sans-serif"},
      {"label": "Sassy Frass", "value": "'Sassy Frass', cursive"},
      {"label": "Satisfy", "value": "Satisfy, cursive"},
      {"label": "Savate", "value": "Savate, sans-serif"},
      {"label": "Sawarabi Gothic", "value": "'Sawarabi Gothic', sans-serif"},
      {"label": "Sawarabi Mincho", "value": "'Sawarabi Mincho', serif"},
      {"label": "Scada", "value": "Scada, sans-serif"},
      {"label": "Scheherazade New", "value": "'Scheherazade New', serif"},
      {"label": "Schibsted Grotesk", "value": "'Schibsted Grotesk', sans-serif"},
      {"label": "Schoolbell", "value": "Schoolbell, cursive"},
      {"label": "Science Gothic", "value": "'Science Gothic', sans-serif"},
      {"label": "Scope One", "value": "'Scope One', serif"},
      {"label": "Scoutie Sans", "value": "'Scoutie Sans', sans-serif"},
      {"label": "Seaweed Script", "value": "'Seaweed Script', sans-serif"},
      {"label": "Secular One", "value": "'Secular One', sans-serif"},
      {"label": "Sedan", "value": "Sedan, serif"},
      {"label": "Sedan SC", "value": "'Sedan SC', serif"},
      {"label": "Sedgwick Ave", "value": "'Sedgwick Ave', cursive"},
      {"label": "Sedgwick Ave Display", "value": "'Sedgwick Ave Display', cursive"},
      {"label": "Segoe UI", "value": "'Segoe UI', Tahoma, sans-serif"},
      {"label": "Sekuya", "value": "Sekuya, sans-serif"},
      {"label": "Sen", "value": "Sen, sans-serif"},
      {"label": "Send Flowers", "value": "'Send Flowers', cursive"},
      {"label": "Sevillana", "value": "Sevillana, sans-serif"},
      {"label": "Seymour One", "value": "'Seymour One', sans-serif"},
      {"label": "Shadows Into Light", "value": "'Shadows Into Light', cursive"},
      {"label": "Shadows Into Light Two", "value": "'Shadows Into Light Two', cursive"},
      {"label": "Shafarik", "value": "Shafarik, sans-serif"},
      {"label": "Shalimar", "value": "Shalimar, cursive"},
      {"label": "Shantell Sans", "value": "'Shantell Sans', sans-serif"},
      {"label": "Shanti", "value": "Shanti, sans-serif"},
      {"label": "Share", "value": "Share, sans-serif"},
      {"label": "Share Tech", "value": "'Share Tech', sans-serif"},
      {"label": "Share Tech Mono", "value": "'Share Tech Mono', monospace"},
      {"label": "Shippori Antique", "value": "'Shippori Antique', sans-serif"},
      {"label": "Shippori Antique B1", "value": "'Shippori Antique B1', sans-serif"},
      {"label": "Shippori Mincho", "value": "'Shippori Mincho', serif"},
      {"label": "Shippori Mincho B1", "value": "'Shippori Mincho B1', serif"},
      {"label": "Shizuru", "value": "Shizuru, sans-serif"},
      {"label": "Shojumaru", "value": "Shojumaru, sans-serif"},
      {"label": "Short Stack", "value": "'Short Stack', cursive"},
      {"label": "Shrikhand", "value": "Shrikhand, sans-serif"},
      {"label": "Siemreap", "value": "Siemreap, sans-serif"},
      {"label": "Sigmar", "value": "Sigmar, sans-serif"},
      {"label": "Sigmar One", "value": "'Sigmar One', sans-serif"},
      {"label": "Signika", "value": "Signika, sans-serif"},
      {"label": "Signika Negative", "value": "'Signika Negative', sans-serif"},
      {"label": "Silkscreen", "value": "Silkscreen, sans-serif"},
      {"label": "Simonetta", "value": "Simonetta, sans-serif"},
      {"label": "Single Day", "value": "'Single Day', sans-serif"},
      {"label": "Sintony", "value": "Sintony, sans-serif"},
      {"label": "Sirin Stencil", "value": "'Sirin Stencil', sans-serif"},
      {"label": "Sirivennela", "value": "Sirivennela, sans-serif"},
      {"label": "Six Caps", "value": "'Six Caps', sans-serif"},
      {"label": "Sixtyfour", "value": "Sixtyfour, monospace"},
      {"label": "Sixtyfour Convergence", "value": "'Sixtyfour Convergence', monospace"},
      {"label": "Skranji", "value": "Skranji, sans-serif"},
      {"label": "Slabo 13px", "value": "'Slabo 13px', serif"},
      {"label": "Slabo 27px", "value": "'Slabo 27px', serif"},
      {"label": "Slackey", "value": "Slackey, sans-serif"},
      {"label": "Slackside One", "value": "'Slackside One', cursive"},
      {"label": "Smokum", "value": "Smokum, sans-serif"},
      {"label": "Smooch", "value": "Smooch, cursive"},
      {"label": "Smooch Sans", "value": "'Smooch Sans', sans-serif"},
      {"label": "Smythe", "value": "Smythe, sans-serif"},
      {"label": "SN Pro", "value": "'SN Pro', sans-serif"},
      {"label": "Sniglet", "value": "Sniglet, sans-serif"},
      {"label": "Snippet", "value": "Snippet, sans-serif"},
      {"label": "Snowburst One", "value": "'Snowburst One', sans-serif"},
      {"label": "Sofadi One", "value": "'Sofadi One', sans-serif"},
      {"label": "Sofia", "value": "Sofia, cursive"},
      {"label": "Sofia Sans", "value": "'Sofia Sans', sans-serif"},
      {"label": "Sofia Sans Condensed", "value": "'Sofia Sans Condensed', sans-serif"},
      {"label": "Sofia Sans Extra Condensed", "value": "'Sofia Sans Extra Condensed', sans-serif"},
      {"label": "Sofia Sans Semi Condensed", "value": "'Sofia Sans Semi Condensed', sans-serif"},
      {"label": "Solitreo", "value": "Solitreo, cursive"},
      {"label": "Solway", "value": "Solway, serif"},
      {"label": "Sometype Mono", "value": "'Sometype Mono', monospace"},
      {"label": "Song Myung", "value": "'Song Myung', serif"},
      {"label": "Sono", "value": "Sono, sans-serif"},
      {"label": "Sonsie One", "value": "'Sonsie One', sans-serif"},
      {"label": "Sora", "value": "Sora, sans-serif"},
      {"label": "Sorts Mill Goudy", "value": "'Sorts Mill Goudy', serif"},
      {"label": "Sour Gummy", "value": "'Sour Gummy', sans-serif"},
      {"label": "Source Code Pro", "value": "'Source Code Pro', monospace"},
      {"label": "Source Sans 3", "value": "'Source Sans 3', sans-serif"},
      {"label": "Source Serif 4", "value": "'Source Serif 4', serif"},
      {"label": "Space Grotesk", "value": "'Space Grotesk', sans-serif"},
      {"label": "Space Mono", "value": "'Space Mono', monospace"},
      {"label": "Special Elite", "value": "'Special Elite', sans-serif"},
      {"label": "Special Gothic", "value": "'Special Gothic', sans-serif"},
      {"label": "Special Gothic Condensed One", "value": "'Special Gothic Condensed One', sans-serif"},
      {"label": "Special Gothic Expanded One", "value": "'Special Gothic Expanded One', sans-serif"},
      {"label": "Spectral", "value": "Spectral, serif"},
      {"label": "Spectral SC", "value": "'Spectral SC', serif"},
      {"label": "Spicy Rice", "value": "'Spicy Rice', sans-serif"},
      {"label": "Spinnaker", "value": "Spinnaker, sans-serif"},
      {"label": "Spirax", "value": "Spirax, sans-serif"},
      {"label": "Splash", "value": "Splash, cursive"},
      {"label": "Spline Sans", "value": "'Spline Sans', sans-serif"},
      {"label": "Spline Sans Mono", "value": "'Spline Sans Mono', monospace"},
      {"label": "Squada One", "value": "'Squada One', sans-serif"},
      {"label": "Square Peg", "value": "'Square Peg', cursive"},
      {"label": "Sree Krushnadevaraya", "value": "'Sree Krushnadevaraya', serif"},
      {"label": "Sriracha", "value": "Sriracha, cursive"},
      {"label": "Srisakdi", "value": "Srisakdi, sans-serif"},
      {"label": "Staatliches", "value": "Staatliches, sans-serif"},
      {"label": "Stack Sans Headline", "value": "'Stack Sans Headline', sans-serif"},
      {"label": "Stack Sans Notch", "value": "'Stack Sans Notch', sans-serif"},
      {"label": "Stack Sans Text", "value": "'Stack Sans Text', sans-serif"},
      {"label": "Stalemate", "value": "Stalemate, cursive"},
      {"label": "Stalinist One", "value": "'Stalinist One', sans-serif"},
      {"label": "Stardos Stencil", "value": "'Stardos Stencil', sans-serif"},
      {"label": "Stick", "value": "Stick, sans-serif"},
      {"label": "Stick No Bills", "value": "'Stick No Bills', sans-serif"},
      {"label": "Stint Ultra Condensed", "value": "'Stint Ultra Condensed', serif"},
      {"label": "Stint Ultra Expanded", "value": "'Stint Ultra Expanded', serif"},
      {"label": "STIX Two Math", "value": "'STIX Two Math', serif"},
      {"label": "STIX Two Text", "value": "'STIX Two Text', serif"},
      {"label": "Stoke", "value": "Stoke, serif"},
      {"label": "Story Script", "value": "'Story Script', sans-serif"},
      {"label": "Strait", "value": "Strait, sans-serif"},
      {"label": "Strichpunkt Sans", "value": "'Strichpunkt Sans', sans-serif"},
      {"label": "Style Script", "value": "'Style Script', cursive"},
      {"label": "Stylish", "value": "Stylish, sans-serif"},
      {"label": "Sue Ellen Francisco", "value": "'Sue Ellen Francisco', cursive"},
      {"label": "Suez One", "value": "'Suez One', serif"},
      {"label": "Sulphur Point", "value": "'Sulphur Point', sans-serif"},
      {"label": "Sumana", "value": "Sumana, serif"},
      {"label": "Sunflower", "value": "Sunflower, sans-serif"},
      {"label": "Sunshiney", "value": "Sunshiney, cursive"},
      {"label": "Supermercado One", "value": "'Supermercado One', sans-serif"},
      {"label": "Sura", "value": "Sura, serif"},
      {"label": "Suranna", "value": "Suranna, serif"},
      {"label": "Suravaram", "value": "Suravaram, serif"},
      {"label": "SUSE", "value": "SUSE, sans-serif"},
      {"label": "SUSE Mono", "value": "'SUSE Mono', sans-serif"},
      {"label": "Suwannaphum", "value": "Suwannaphum, serif"},
      {"label": "Swanky and Moo Moo", "value": "'Swanky and Moo Moo', cursive"},
      {"label": "Syncopate", "value": "Syncopate, sans-serif"},
      {"label": "Syne", "value": "Syne, sans-serif"},
      {"label": "Syne Mono", "value": "'Syne Mono', monospace"},
      {"label": "Syne Tactile", "value": "'Syne Tactile', sans-serif"},
      {"label": "Tac One", "value": "'Tac One', sans-serif"},
      {"label": "Tagesschrift", "value": "Tagesschrift, sans-serif"},
      {"label": "Tahoma", "value": "Tahoma, Geneva, sans-serif"},
      {"label": "Tai Heritage Pro", "value": "'Tai Heritage Pro', serif"},
      {"label": "Tajawal", "value": "Tajawal, sans-serif"},
      {"label": "Tangerine", "value": "Tangerine, cursive"},
      {"label": "Tapestry", "value": "Tapestry, cursive"},
      {"label": "Taprom", "value": "Taprom, sans-serif"},
      {"label": "TASA Explorer", "value": "'TASA Explorer', sans-serif"},
      {"label": "TASA Orbiter", "value": "'TASA Orbiter', sans-serif"},
      {"label": "Tauri", "value": "Tauri, sans-serif"},
      {"label": "Taviraj", "value": "Taviraj, serif"},
      {"label": "Teachers", "value": "Teachers, sans-serif"},
      {"label": "Teko", "value": "Teko, sans-serif"},
      {"label": "Tektur", "value": "Tektur, sans-serif"},
      {"label": "Telex", "value": "Telex, sans-serif"},
      {"label": "Tenali Ramakrishna", "value": "'Tenali Ramakrishna', sans-serif"},
      {"label": "Tenor Sans", "value": "'Tenor Sans', sans-serif"},
      {"label": "Text Me One", "value": "'Text Me One', sans-serif"},
      {"label": "Texturina", "value": "Texturina, serif"},
      {"label": "Thasadith", "value": "Thasadith, sans-serif"},
      {"label": "The Girl Next Door", "value": "'The Girl Next Door', cursive"},
      {"label": "The Nautigal", "value": "'The Nautigal', cursive"},
      {"label": "Tienne", "value": "Tienne, serif"},
      {"label": "TikTok Sans", "value": "'TikTok Sans', sans-serif"},
      {"label": "Tillana", "value": "Tillana, sans-serif"},
      {"label": "Tilt Neon", "value": "'Tilt Neon', sans-serif"},
      {"label": "Tilt Prism", "value": "'Tilt Prism', sans-serif"},
      {"label": "Tilt Warp", "value": "'Tilt Warp', sans-serif"},
      {"label": "Times New Roman", "value": "'Times New Roman', Times, serif"},
      {"label": "Timmana", "value": "Timmana, sans-serif"},
      {"label": "Tinos", "value": "Tinos, serif"},
      {"label": "Tiny5", "value": "'Tiny5', sans-serif"},
      {"label": "Tiro Bangla", "value": "'Tiro Bangla', serif"},
      {"label": "Tiro Devanagari Hindi", "value": "'Tiro Devanagari Hindi', serif"},
      {"label": "Tiro Devanagari Marathi", "value": "'Tiro Devanagari Marathi', serif"},
      {"label": "Tiro Devanagari Sanskrit", "value": "'Tiro Devanagari Sanskrit', serif"},
      {"label": "Tiro Gurmukhi", "value": "'Tiro Gurmukhi', serif"},
      {"label": "Tiro Kannada", "value": "'Tiro Kannada', serif"},
      {"label": "Tiro Tamil", "value": "'Tiro Tamil', serif"},
      {"label": "Tiro Telugu", "value": "'Tiro Telugu', serif"},
      {"label": "Tirra", "value": "Tirra, sans-serif"},
      {"label": "Titan One", "value": "'Titan One', sans-serif"},
      {"label": "Titillium Web", "value": "'Titillium Web', sans-serif"},
      {"label": "Tomorrow", "value": "Tomorrow, sans-serif"},
      {"label": "Tourney", "value": "Tourney, sans-serif"},
      {"label": "Trade Winds", "value": "'Trade Winds', sans-serif"},
      {"label": "Train One", "value": "'Train One', sans-serif"},
      {"label": "Trebuchet MS", "value": "'Trebuchet MS', Helvetica, sans-serif"},
      {"label": "Triodion", "value": "Triodion, sans-serif"},
      {"label": "Trirong", "value": "Trirong, serif"},
      {"label": "Trispace", "value": "Trispace, sans-serif"},
      {"label": "Trocchi", "value": "Trocchi, serif"},
      {"label": "Trochut", "value": "Trochut, sans-serif"},
      {"label": "Truculenta", "value": "Truculenta, sans-serif"},
      {"label": "Trykker", "value": "Trykker, serif"},
      {"label": "Tsukimi Rounded", "value": "'Tsukimi Rounded', sans-serif"},
      {"label": "Tuffy", "value": "Tuffy, sans-serif"},
      {"label": "Tulpen One", "value": "'Tulpen One', sans-serif"},
      {"label": "Turret Road", "value": "'Turret Road', sans-serif"},
      {"label": "Twinkle Star", "value": "'Twinkle Star', cursive"},
      {"label": "Ubuntu", "value": "Ubuntu, sans-serif"},
      {"label": "Ubuntu Condensed", "value": "'Ubuntu Condensed', sans-serif"},
      {"label": "Ubuntu Mono", "value": "'Ubuntu Mono', monospace"},
      {"label": "Ubuntu Sans", "value": "'Ubuntu Sans', sans-serif"},
      {"label": "Ubuntu Sans Mono", "value": "'Ubuntu Sans Mono', monospace"},
      {"label": "Uchen", "value": "Uchen, serif"},
      {"label": "Ultra", "value": "Ultra, serif"},
      {"label": "Unbounded", "value": "Unbounded, sans-serif"},
      {"label": "Uncial Antiqua", "value": "'Uncial Antiqua', sans-serif"},
      {"label": "Underdog", "value": "Underdog, sans-serif"},
      {"label": "Unica One", "value": "'Unica One', sans-serif"},
      {"label": "UnifrakturCook", "value": "UnifrakturCook, sans-serif"},
      {"label": "UnifrakturMaguntia", "value": "UnifrakturMaguntia, sans-serif"},
      {"label": "Unkempt", "value": "Unkempt, sans-serif"},
      {"label": "Unlock", "value": "Unlock, sans-serif"},
      {"label": "Unna", "value": "Unna, serif"},
      {"label": "UoqMunThenKhung", "value": "UoqMunThenKhung, serif"},
      {"label": "Updock", "value": "Updock, cursive"},
      {"label": "Urbanist", "value": "Urbanist, sans-serif"},
      {"label": "Valley Sans", "value": "'Valley Sans', sans-serif"},
      {"label": "Vampiro One", "value": "'Vampiro One', sans-serif"},
      {"label": "Varela", "value": "Varela, sans-serif"},
      {"label": "Varela Round", "value": "'Varela Round', sans-serif"},
      {"label": "Varta", "value": "Varta, sans-serif"},
      {"label": "Vast Shadow", "value": "'Vast Shadow', serif"},
      {"label": "Vazirmatn", "value": "Vazirmatn, sans-serif"},
      {"label": "Vend Sans", "value": "'Vend Sans', sans-serif"},
      {"label": "Verdana", "value": "Verdana, Geneva, sans-serif"},
      {"label": "Vesper Libre", "value": "'Vesper Libre', serif"},
      {"label": "Viaoda Libre", "value": "'Viaoda Libre', sans-serif"},
      {"label": "Vibes", "value": "Vibes, sans-serif"},
      {"label": "Vibur", "value": "Vibur, cursive"},
      {"label": "Victor Mono", "value": "'Victor Mono', monospace"},
      {"label": "Vidaloka", "value": "Vidaloka, serif"},
      {"label": "Viga", "value": "Viga, sans-serif"},
      {"label": "Vina Sans", "value": "'Vina Sans', sans-serif"},
      {"label": "Voces", "value": "Voces, sans-serif"},
      {"label": "Volkhov", "value": "Volkhov, serif"},
      {"label": "Vollkorn", "value": "Vollkorn, serif"},
      {"label": "Vollkorn SC", "value": "'Vollkorn SC', serif"},
      {"label": "Voltaire", "value": "Voltaire, sans-serif"},
      {"label": "VT323", "value": "'VT323', monospace"},
      {"label": "Vujahday Script", "value": "'Vujahday Script', cursive"},
      {"label": "Waiting for the Sunrise", "value": "'Waiting for the Sunrise', cursive"},
      {"label": "Wallpoet", "value": "Wallpoet, sans-serif"},
      {"label": "Walter Turncoat", "value": "'Walter Turncoat', cursive"},
      {"label": "Warnes", "value": "Warnes, sans-serif"},
      {"label": "Water Brush", "value": "'Water Brush', cursive"},
      {"label": "Waterfall", "value": "Waterfall, cursive"},
      {"label": "Wavefont", "value": "Wavefont, sans-serif"},
      {"label": "WDXL Lubrifont JP N", "value": "'WDXL Lubrifont JP N', sans-serif"},
      {"label": "WDXL Lubrifont SC", "value": "'WDXL Lubrifont SC', sans-serif"},
      {"label": "WDXL Lubrifont TC", "value": "'WDXL Lubrifont TC', sans-serif"},
      {"label": "Wellfleet", "value": "Wellfleet, serif"},
      {"label": "Wendy One", "value": "'Wendy One', sans-serif"},
      {"label": "Whisper", "value": "Whisper, cursive"},
      {"label": "WindSong", "value": "WindSong, cursive"},
      {"label": "Winky Rough", "value": "'Winky Rough', sans-serif"},
      {"label": "Winky Sans", "value": "'Winky Sans', sans-serif"},
      {"label": "Wire One", "value": "'Wire One', sans-serif"},
      {"label": "Wittgenstein", "value": "Wittgenstein, serif"},
      {"label": "Wix Madefor Display", "value": "'Wix Madefor Display', sans-serif"},
      {"label": "Wix Madefor Text", "value": "'Wix Madefor Text', sans-serif"},
      {"label": "Work Sans", "value": "'Work Sans', sans-serif"},
      {"label": "Workbench", "value": "Workbench, monospace"},
      {"label": "Xanh Mono", "value": "'Xanh Mono', monospace"},
      {"label": "Yaldevi", "value": "Yaldevi, sans-serif"},
      {"label": "Yanone Kaffeesatz", "value": "'Yanone Kaffeesatz', sans-serif"},
      {"label": "Yantramanav", "value": "Yantramanav, sans-serif"},
      {"label": "Yarndings 12", "value": "'Yarndings 12', sans-serif"},
      {"label": "Yarndings 12 Charted", "value": "'Yarndings 12 Charted', sans-serif"},
      {"label": "Yarndings 20", "value": "'Yarndings 20', sans-serif"},
      {"label": "Yarndings 20 Charted", "value": "'Yarndings 20 Charted', sans-serif"},
      {"label": "Yatra One", "value": "'Yatra One', sans-serif"},
      {"label": "Yellowtail", "value": "Yellowtail, cursive"},
      {"label": "Yeon Sung", "value": "'Yeon Sung', sans-serif"},
      {"label": "Yeseva One", "value": "'Yeseva One', sans-serif"},
      {"label": "Yesteryear", "value": "Yesteryear, cursive"},
      {"label": "Yomogi", "value": "Yomogi, cursive"},
      {"label": "Young Serif", "value": "'Young Serif', serif"},
      {"label": "Yrsa", "value": "Yrsa, serif"},
      {"label": "Ysabeau", "value": "Ysabeau, sans-serif"},
      {"label": "Ysabeau Infant", "value": "'Ysabeau Infant', sans-serif"},
      {"label": "Ysabeau Office", "value": "'Ysabeau Office', sans-serif"},
      {"label": "Ysabeau SC", "value": "'Ysabeau SC', sans-serif"},
      {"label": "Yuji Boku", "value": "'Yuji Boku', serif"},
      {"label": "Yuji Hentaigana Akari", "value": "'Yuji Hentaigana Akari', cursive"},
      {"label": "Yuji Hentaigana Akebono", "value": "'Yuji Hentaigana Akebono', cursive"},
      {"label": "Yuji Mai", "value": "'Yuji Mai', serif"},
      {"label": "Yuji Syuku", "value": "'Yuji Syuku', serif"},
      {"label": "Yusei Magic", "value": "'Yusei Magic', sans-serif"},
      {"label": "Yuyu", "value": "Yuyu, cursive"},
      {"label": "Yuyu Short", "value": "'Yuyu Short', cursive"},
      {"label": "Zain", "value": "Zain, sans-serif"},
      {"label": "Zalando Sans", "value": "'Zalando Sans', sans-serif"},
      {"label": "Zalando Sans Expanded", "value": "'Zalando Sans Expanded', sans-serif"},
      {"label": "Zalando Sans SemiExpanded", "value": "'Zalando Sans SemiExpanded', sans-serif"},
      {"label": "ZCOOL KuaiLe", "value": "'ZCOOL KuaiLe', sans-serif"},
      {"label": "ZCOOL QingKe HuangYou", "value": "'ZCOOL QingKe HuangYou', sans-serif"},
      {"label": "ZCOOL XiaoWei", "value": "'ZCOOL XiaoWei', sans-serif"},
      {"label": "Zen Antique", "value": "'Zen Antique', serif"},
      {"label": "Zen Antique Soft", "value": "'Zen Antique Soft', serif"},
      {"label": "Zen Dots", "value": "'Zen Dots', sans-serif"},
      {"label": "Zen Kaku Gothic Antique", "value": "'Zen Kaku Gothic Antique', sans-serif"},
      {"label": "Zen Kaku Gothic New", "value": "'Zen Kaku Gothic New', sans-serif"},
      {"label": "Zen Kurenaido", "value": "'Zen Kurenaido', sans-serif"},
      {"label": "Zen Loop", "value": "'Zen Loop', sans-serif"},
      {"label": "Zen Maru Gothic", "value": "'Zen Maru Gothic', sans-serif"},
      {"label": "Zen Old Mincho", "value": "'Zen Old Mincho', serif"},
      {"label": "Zen Tokyo Zoo", "value": "'Zen Tokyo Zoo', sans-serif"},
      {"label": "Zeyada", "value": "Zeyada, cursive"},
      {"label": "Zhi Mang Xing", "value": "'Zhi Mang Xing', cursive"},
      {"label": "Zilla Slab", "value": "'Zilla Slab', serif"},
      {"label": "Zilla Slab Highlight", "value": "'Zilla Slab Highlight', serif"}
    ],
    "// fontWeights": "Shared weights for the 'Axis label weight' format control. Values are ECharts/CSS fontWeight tokens; numeric strings are converted to numbers for canvas text. Empty value = keep the theme default.",
    "fontWeights": [
      { "label": "Default", "value": "" },
      { "label": "Normal", "value": "normal" },
      { "label": "Medium (500)", "value": "500" },
      { "label": "Semi-bold (600)", "value": "600" },
      { "label": "Bold", "value": "bold" }
    ],
    "// formatControls": "SHARED per-tile Format-popup controls that apply to ALL chart tiles (no appliesTo). Each chart adds its OWN controls from its chart file (see chartConfigs) and they are concatenated onto this list.",
    "formatControls": [
      {
        "key": "title",
        "label": "Chart title",
        "control": "text",
        "enabled": true,
        "group": "Title"
      },
      {
        "key": "titleAlign",
        "label": "Title alignment",
        "control": "select",
        "optionsKey": "titleAlignments",
        "default": "left",
        "enabled": true,
        "group": "Title"
      },
      {
        "key": "showValues",
        "label": "Show data labels",
        "control": "toggle",
        "default": true,
        "enabled": true,
        "group": "Labels"
      },
      {
        "key": "numberFormat",
        "label": "Number format",
        "control": "select",
        "optionsKey": "numberFormats",
        "default": "NONE",
        "enabled": true,
        "group": "Formatting"
      },
      {
        "key": "fontFamily",
        "label": "Font family",
        "control": "select",
        "optionsKey": "fontFamilies",
        "default": "",
        "enabled": true,
        "group": "Formatting"
      },
      {
        "key": "fontSize",
        "label": "Font size (px, 0 = default)",
        "control": "number",
        "default": 0,
        "min": 0,
        "max": 48,
        "step": 1,
        "enabled": true,
        "group": "Formatting"
      },
      {
        "// axisFontWeight": "Axis-ONLY font weight — X/Y tick labels + axis titles, so axes can be highlighted independently of the rest of the chart text. Scoped to the axis-bearing ECharts families (HTML widgets have no axes).",
        "key": "axisFontWeight",
        "label": "Axis label weight",
        "control": "select",
        "optionsKey": "fontWeights",
        "default": "",
        "enabled": true,
        "group": "Formatting",
        "appliesTo": ["BAR", "LINE_AREA", "SCATTER_BUBBLE", "WATERFALL"]
      },
      { "// decimals": "SHARED across every tile's Format popup, like numberFormat above. Every option builder reads format.decimals (BAR/LINE_AREA/SCATTER_BUBBLE in their formatValue, WATERFALL via the recompute utils, KPI/TABLE_MATRIX/SLIDER in their own) and falls back to 1 when unset - so an appliesTo gate here left those tiles reading a decimals value the user had no control to change.", "key": "decimals", "label": "Decimal places (round off)", "control": "number", "default": 1, "min": 0, "max": 6, "step": 1, "enabled": true, "group": "Formatting" },
      {
        "key": "cardHeaderBackground",
        "label": "Card header background",
        "control": "color",
        "default": "#ffffff",
        "enabled": true,
        "group": "Formatting"
      },
      {
        "key": "cardHeaderColor",
        "label": "Card header text color",
        "control": "color",
        "default": "#172033",
        "enabled": true,
        "group": "Formatting"
      },
      {
        "key": "cardTransparent",
        "label": "Transparent card",
        "control": "toggle",
        "default": false,
        "enabled": true,
        "appliesTo": [
          "GROUP"
        ],
        "group": "Card"
      },
      {
        "key": "cardBackground",
        "label": "Card background",
        "control": "color",
        "default": "#ffffff",
        "enabled": true,
        "appliesTo": [
          "GROUP"
        ],
        "group": "Card"
      },
      {
        "key": "cardHeaderBackground",
        "label": "Header background",
        "control": "color",
        "default": "#eef3f9",
        "enabled": true,
        "appliesTo": [
          "GROUP"
        ],
        "group": "Card"
      },
      {
        "key": "cardHeaderColor",
        "label": "Header text color",
        "control": "color",
        "default": "#2a3a54",
        "enabled": true,
        "appliesTo": [
          "GROUP"
        ],
        "group": "Card"
      },
      {
        "key": "titleAlign",
        "label": "Title alignment",
        "control": "select",
        "optionsKey": "titleAlignments",
        "default": "left",
        "enabled": true,
        "appliesTo": [
          "GROUP"
        ],
        "group": "Card"
      },
      {
        "key": "cardBorderColor",
        "label": "Border color",
        "control": "color",
        "default": "#b7cbe6",
        "enabled": true,
        "appliesTo": [
          "GROUP"
        ],
        "group": "Card"
      },
      {
        "key": "cardBorderWidth",
        "label": "Border width (px)",
        "control": "number",
        "default": 1,
        "min": 0,
        "max": 6,
        "step": 1,
        "enabled": true,
        "appliesTo": [
          "GROUP"
        ],
        "group": "Card"
      },
      {
        "key": "cardCornerRadius",
        "label": "Corner radius (px)",
        "control": "number",
        "default": 12,
        "min": 0,
        "max": 28,
        "step": 1,
        "enabled": true,
        "appliesTo": [
          "GROUP"
        ],
        "group": "Card"
      }
    ],
    "// formulaBuilder": "SHARED, chart-agnostic Formula Builder config. Any chart's build form can render a Formula Builder that creates row-level COMPUTED columns from the dataset's columns (reuses SelfServiceFormulaService). `enabled` gates it; `title`/`hint`/`addLabel`/placeholders are UI text; `namePattern`/`nameError` validate the column name; `templates` are quick-fill chips (kind:'column' = row-level; aggregation templates are ignored here). Templates use GENERIC placeholders ([ColumnA]/[Numerator]/…) so they work with ANY dataset — the user swaps in real column names.",
    "formulaBuilder": {
      "enabled": true,
      "title": "Formula columns",
      "hint": "Build a computed column from your dataset's columns. It then appears in EVERY picker above — Category (the axis), Split / Legend, and Measures — so an axis or a series can be a formula, not just a raw column. Operators: + - * / and parentheses. Reference columns by name; for names with spaces use [Column Name]. Functions: IF(cond,then,else), concat, abs/round/sqrt/min/max.",
      "namePlaceholder": "Column name (e.g. Margin)",
      "expressionPlaceholder": "Expression (e.g. ([Profit] / [Revenue]) * 100)",
      "addLabel": "Add column",
      "templatesLabel": "Quick templates:",
      "namePattern": "^[A-Za-z_][A-Za-z0-9_ ]*$",
      "nameError": "Name must start with a letter/underscore (letters, digits, spaces, underscores only).",
      "templates": [
        {
          "id": "derived-margin",
          "label": "Margin",
          "kind": "column",
          "category": "Derived",
          "description": "Row-level margin %",
          "defaultName": "Margin",
          "expressionTemplate": "([Profit] / [Revenue]) * 100"
        },
        {
          "id": "derived-diff",
          "label": "Diff",
          "kind": "column",
          "category": "Derived",
          "description": "Row-level difference",
          "defaultName": "Diff",
          "expressionTemplate": "[ColumnA] - [ColumnB]"
        },
        {
          "id": "derived-pct",
          "label": "Percent of",
          "kind": "column",
          "category": "Percentage",
          "description": "Row-level percentage of two columns",
          "defaultName": "Percent",
          "expressionTemplate": "([Part] / [Whole]) * 100"
        },
        {
          "id": "derived-ratio",
          "label": "Ratio",
          "kind": "column",
          "category": "Ratio",
          "description": "Ratio of two columns",
          "defaultName": "Ratio",
          "expressionTemplate": "[Numerator] / [Denominator]"
        },
        {
          "id": "derived-concat",
          "label": "Concat",
          "kind": "column",
          "category": "Derived",
          "description": "Concatenate two text columns",
          "defaultName": "Label",
          "expressionTemplate": "concat([First], \" - \", [Second])"
        }
      ]
    },
    "// navigation": "Table → dashboard navigation is configured in the builder FORM (the Table & Matrix section), not the per-tile Format popup — it needs dataset columns + the user's saved dashboards + multiselect, which the form provides. navButtonLabelDefault is the only static knob; everything else is dynamic.",
    "navButtonLabelDefault": "Navigate",
    "// upload": "The table's file-upload knobs (enableUpload/uploadButtonLabel/uploadAccept/uploadUrl) are Format-popup controls (Upload group). The picked file POSTs as multipart FormData to uploadUrl (or the compute API) WITH the table's componentId + dataset, and the response rows re-render the table.",
    "entityGroup": "NontimeSeriesEntities",
    "hiddenColumns": [
      "uuid",
      "__rowKey",
      "source_row_hash",
      "sourced_row_hash",
      "spriced_row_hash"
    ]
  },
  "publishedView": {
    "route": "/dvm-published",
    "loadMode": "snapshot",
    "cachePolicy": "api-first",
    "computeOnOpen": true,
    "preserveSnapshotFallback": false,
    "sharedUsersCanEditLayout": true,
    "features": {
      "backToBuilder": true,
      "share": true,
      "editLayout": true
    },
    "recomputeEndpointKey": "generateConfigApi"
  },
  "defaults": {
    "componentType": "CHART",
    "dashboardId": 101
  },
  "apiEndpoints": {
    "baseUrl": "",
    "attributeApi": "/getEntityAttributes/NontimeSeriesEntities",
    "generateConfigApi": "/components/compute",
    "filterApi": "/getData",
    "publishApi": "",
    "deleteComponentApi": "/deleteEntityRow",
    "deleteComponentEntityName": "component_definitions",
    "deleteComponentKeyColumn": "component_id"
  }
}
